import { Icon } from 'models/icons'

export default function SpainFlag({ width, height }: Icon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width={width}
      height={height || 500}
      viewBox="0 0 750 500"
      xmlSpace="preserve"
      data-testid="flag"
    >
      <path fill="#ad1519" d="M0 0h750v500H0z" />
      <path fill="#fabd00" d="M0 125h750v250H0z" />
      <path
        fill="#b50027"
        d="M249.843 223.055c-10.726-.015-20.42-1.364-27.8-3.443 7.38-2.08 17.074-3.353 27.8-3.375 10.723.022 20.47 1.294 27.849 3.375-7.38 2.079-17.126 3.428-27.85 3.443"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeWidth={0.243}
          d="M335.649 219.274c0-5.408 4.622-9.781 10.313-9.781 5.667 0 10.308 4.373 10.308 9.78 0 5.39-4.622 9.763-10.308 9.763-5.69 0-10.313-4.373-10.313-9.762z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          strokeWidth={1.232}
          d="M451.967 134.945c31.61 0 59.737 4.68 78.06 11.942 10.485 4.732 24.563 8.229 39.973 10.289 11.735 1.57 22.887 1.892 32.587 1.15 12.971-.255 31.734 3.544 50.502 11.807 15.534 6.893 28.5 15.27 37.113 23.38l-7.453 6.639-2.155 18.849-20.45 23.414-10.217 8.67-24.204 19.375-12.363 1.011-3.76 10.696L453 263.821l-157.077 18.346-3.765-10.696-12.382-1.01-24.2-19.376-10.222-8.67L224.915 219l-2.126-18.849-7.492-6.639c8.651-8.11 21.623-16.487 37.119-23.38 18.768-8.263 37.535-12.062 50.497-11.808 9.7.743 20.856.422 32.592-1.15 15.415-2.06 29.507-5.556 39.973-10.288 18.342-7.262 44.898-11.942 76.489-11.942z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00" strokeWidth={1.857}>
          <path
            d="m564.539 181.605-9.896-16.167c10.734-6.571 18.101-17.991 18.101-31 0-1.471-.086-2.904-.263-4.326-1.02-20.626-26.188-37.67-58.066-37.67-16.588 0-31.523 4.527-42.057 11.794-.287-3.195-.536-5.93-1.02-8.838 11.597-6.758 26.633-10.825 43.077-10.825 36.678 0 65.376 20.841 66.784 45.524a50.34 50.34 0 0 1 .196 4.34c0 13.163-6.006 25.019-15.515 33.262l5.26 8.618zm-221.636 0 9.897-16.167c-10.735-6.571-18.102-17.991-18.102-31 0-1.471.086-2.904.263-4.326 1.02-20.626 26.188-37.67 58.066-37.67 16.588 0 31.524 4.527 42.057 11.794.288-3.195.537-5.93 1.02-8.838-11.596-6.758-26.633-10.825-43.077-10.825-36.678 0-65.375 20.841-66.784 45.524a50.34 50.34 0 0 0-.196 4.34c0 13.163 6.007 25.019 15.515 33.262l-5.26 8.618z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M591.014 140.468c0-16.114-10.548-30.489-26.542-40.016 9.863 7.937 15.85 18.192 16.727 29.645.124 1.437.196 2.889.196 4.34 0 13.163-6.006 25.019-15.515 33.262l4.833 8.8c12.522-9.34 20.3-22.044 20.3-36.031zM226.272 192.818c-7.013-7.855-11.31-18.005-11.31-29.104a42.605 42.605 0 0 1 4.35-18.8c10.13-20.847 41.918-36.017 79.697-36.017 10.294 0 20.143 1.116 29.239 3.19-2.017 2.199-3.602 4.613-5.145 7.046-7.558-1.47-15.654-2.266-24.094-2.266-34.584 0-63.517 13.45-71.9 31.624a34.993 34.993 0 0 0-3.482 15.223c0 11.046 5.174 20.947 13.274 27.706l-12.522 20.453-6.706-5.336 8.599-13.7v-.018zM453.82 80.449c8.383 0 15.592 5.542 17.307 12.976 1.121 6.572 1.82 14.054 1.979 22.024.015.83-.058 1.639-.058 2.453.025.944.201 1.96.215 2.922.288 16.722 2.678 31.485 6.084 40.524l-25.54 24.429-25.815-24.43c3.425-9.038 5.796-23.801 6.117-40.523.02-.963.201-1.978.201-2.922 0-.814-.057-1.624-.038-2.453.124-7.97.838-15.452 1.964-22.024 1.696-7.434 9.202-12.976 17.57-12.976z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <g fill="none" strokeWidth={1.082}>
          <path
            strokeWidth={0.108}
            d="M193.384 229.571v-6.522m-1.772 6.522v-6.522"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
          <path
            strokeWidth={0.27}
            d="M189.94 229.571v-6.522m-1.658 6.522v-6.522m-1.477 6.522v-6.522m-2.818 6.171-.039-5.937m1.375 6.015v-6.21"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
          <path
            strokeWidth={0.541}
            d="M181.386 228.953v-5.47m1.318 5.626-.039-5.821m-4.768 5.352v-4.805m1.145 4.883v-5.039m1.179 5.196v-5.236"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
          <path
            strokeWidth={0.811}
            d="M176.673 228.601v-4.649m-1.14 4.745v-5.087m-1.223 4.939v-4.744m-2.504 4.333-.039-4.014m1.322 4.26v-4.434"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
          <path
            d="M170.522 228.045v-3.624m-1.175 3.665v-3.482m-1.283 2.81v-2.615m-1.319 2.639v-2.387m-1.396 2.075v-1.774"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
          <path
            strokeWidth={0.108}
            d="M200.432 229.22v-5.976m-3.001 6.171.039-6.327m-2.226 6.405v-6.444"
            transform="matrix(1.0936 0 0 1.24173 43.017 -61.388)"
          />
        </g>
        <g strokeWidth={1.859}>
          <g fill="#9f7e00">
            <path
              d="M454.37 293.734c-58.342.087-110.608 6.995-147.903 18.213-2.64.795-4.046 3.075-3.998 5.59-.158 2.587 1.267 5.087 3.998 5.916 37.295 11.233 89.56 18.14 147.904 18.227 58.334-.087 110.56-6.994 147.861-18.227 2.711-.829 4.12-3.33 3.977-5.916.048-2.515-1.337-4.795-3.977-5.59-37.3-11.218-89.527-18.126-147.861-18.213zm-.142 9.58c52.644.101 100.486 5.831 136.713 15.206-36.227 9.36-84.07 15.436-136.713 15.503-52.652-.067-100.243-6.144-136.47-15.503 36.227-9.375 83.818-15.105 136.47-15.206z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="M453.964 293.687c-59.043.115-112.035 7.516-149.336 19.002 3.1-1.47 2.821-5.288-1.035-15.218-4.656-12.013-11.913-11.486-11.913-11.486 41.238-12.181 98.643-19.802 162.533-19.884 63.915.082 121.78 7.703 163.022 19.884 0 0-7.262-.527-11.918 11.486-3.851 9.93-4.139 13.748-1.035 15.218-37.295-11.486-91.28-18.887-150.318-19.002"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="M454.213 266.116c-63.89.1-121.295 7.702-162.533 19.902-2.75.824-5.657-.253-6.548-2.854-.89-2.606.59-5.595 3.339-6.438 41.415-12.703 100.3-20.679 165.757-20.813 65.47.12 124.58 8.11 166 20.813 2.75.843 4.23 3.832 3.34 6.438-.896 2.6-3.804 3.678-6.549 2.854-41.242-12.2-98.891-19.802-162.806-19.902"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
          </g>
          <path
            fill="#fff"
            d="M408.64 280.63c0-2.721 2.333-4.934 5.207-4.934 2.893 0 5.23 2.213 5.23 4.934 0 2.716-2.337 4.948-5.23 4.948-2.874 0-5.207-2.232-5.207-4.948"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M454.343 284.514h-15.635c-2.884 0-5.274-2.198-5.274-4.933 0-2.721 2.337-4.949 5.212-4.949h31.6c2.874 0 5.216 2.228 5.216 4.949 0 2.735-2.39 4.933-5.288 4.933z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#006f46"
            d="m375.804 288.82-11.247 1.304c-2.87.335-5.528-1.59-5.887-4.278-.35-2.716 1.686-5.183 4.555-5.504l11.31-1.317 11.506-1.322c2.85-.335 5.456 1.557 5.815 4.277.335 2.702-1.749 5.183-4.603 5.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#fff"
            d="M330.102 289.803c0-2.721 2.337-4.934 5.207-4.934 2.893 0 5.226 2.213 5.226 4.934 0 2.735-2.333 4.948-5.226 4.948-2.87 0-5.207-2.213-5.207-4.948"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="m296.38 297.29 4.756-6.089 16.018 2.026-12.809 9.346-7.094-2.73-2.03-.923z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#006f46"
            d="m532.896 288.82 11.237 1.304c2.85.335 5.533-1.59 5.887-4.278.321-2.716-1.696-5.183-4.55-5.504l-11.305-1.317-11.506-1.322c-2.874-.335-5.475 1.557-5.815 4.277-.36 2.702 1.748 5.183 4.598 5.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#fff"
            d="M489.622 280.63c0-2.721 2.337-4.934 5.211-4.934 2.889 0 5.226 2.213 5.226 4.934 0 2.716-2.337 4.948-5.226 4.948-2.874 0-5.211-2.232-5.211-4.948m78.538 9.173c0-2.721 2.338-4.934 5.212-4.934 2.888 0 5.226 2.213 5.226 4.934 0 2.735-2.338 4.948-5.226 4.948-2.874 0-5.212-2.213-5.212-4.948"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="m613.36 298.789-5.796-7.588-16.018 2.026 12.808 9.346 8.623-2.774.903-.294z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="#9f7e00"
          strokeWidth={1.857}
          d="M453.82 88.405c4.355 0 8.024 2.773 8.92 6.62 1.054 6.217 1.729 13.316 1.873 20.812 0 .781-.04 1.557-.04 2.314 0 .93.163 1.859.182 2.807.268 15.793 2.534 29.713 5.777 38.277l-16.838 15.946-16.856-15.946c3.214-8.545 5.48-22.484 5.762-38.277.02-.948.182-1.878.197-2.807 0-.757-.053-1.533-.053-2.314.144-7.496.82-14.595 1.887-20.812.877-3.847 4.853-6.62 9.188-6.62z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#fff"
        d="M247.91 185.412c0-1.05.83-1.897 1.847-1.897s1.846.848 1.846 1.897c0 1.054-.828 1.906-1.846 1.906s-1.846-.852-1.846-1.906"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeWidth={1.857}
          d="M444.743 164.49c0-4.728 4.067-8.545 9.063-8.545s9.063 3.817 9.063 8.545c0 4.747-4.067 8.584-9.063 8.584s-9.063-3.837-9.063-8.584z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g strokeWidth={1.859}>
          <path
            fill="#fff"
            d="M444.743 147.682c0-4.728 4.067-8.584 9.063-8.584s9.063 3.856 9.063 8.584c0 4.732-4.067 8.564-9.063 8.564s-9.063-3.832-9.063-8.564m1.821-18.078c0-3.784 3.247-6.84 7.242-6.84 3.976 0 7.224 3.056 7.224 6.84s-3.248 6.845-7.224 6.845c-3.995 0-7.242-3.06-7.242-6.845m2.031-16.3c0-2.716 2.337-4.93 5.211-4.93 2.889 0 5.207 2.214 5.207 4.93 0 2.74-2.318 4.952-5.207 4.952-2.874 0-5.211-2.213-5.211-4.952m1.035-14.256c0-2.198 1.867-3.951 4.176-3.951 2.3 0 4.172 1.753 4.172 3.951 0 2.18-1.873 3.952-4.172 3.952-2.309 0-4.177-1.772-4.177-3.952"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="m454.573 216.079 5.887 1.082c-.949 2.381-1.145 4.982-1.145 7.722 0 12.21 10.49 22.144 23.404 22.144 10.366 0 19.194-6.418 22.226-15.285.34.235 2.233-8.009 3.21-7.908.819.086.733 8.565 1.034 8.411 1.5 11.166 11.703 18.72 23.19 18.72 12.894 0 23.351-9.882 23.351-22.116 0-.91-.053-1.82-.177-2.701l7.329-7.262 3.937 9.254c-1.566 2.908-2.189 6.17-2.189 9.667 0 11.673 9.988 21.114 22.317 21.114 7.755 0 14.567-3.731 18.567-9.393l4.69-5.964-.036 7.315c0 7.348 3.104 13.939 10.275 15.103 0 0 8.234.507 19.141-8.057 10.917-8.565 16.929-15.659 16.929-15.659l.938 8.58s-9.058 14.005-18.92 19.715c-5.39 3.142-13.576 6.433-20.085 5.37-6.889-1.116-11.794-6.64-14.323-13.005-4.91 2.888-10.706 4.574-16.914 4.574-13.34 0-25.33-7.314-30.072-18.327-6.136 6.62-14.682 10.692-24.702 10.692-10.654 0-20.411-4.795-26.528-12.162-6.012 5.475-14.184 8.852-23.189 8.852-11.793 0-22.312-5.777-28.276-14.495-5.954 8.718-16.464 14.495-28.238 14.495-9 0-17.191-3.377-23.208-8.852-6.093 7.367-15.87 12.162-26.518 12.162-10.025 0-18.57-4.072-24.712-10.692-4.737 11.013-16.722 18.327-30.067 18.327-6.213 0-11.985-1.686-16.89-4.574-2.553 6.366-7.458 11.889-14.327 13.005-6.51 1.063-14.696-2.228-20.1-5.37-9.867-5.71-18.916-19.716-18.916-19.716l.949-8.579s6.016 7.094 16.914 15.659c10.916 8.579 19.14 8.057 19.14 8.057 7.172-1.164 10.27-7.755 10.27-15.103l-.033-7.315 4.69 5.964c3.995 5.662 10.83 9.393 18.571 9.393 12.325 0 22.312-9.441 22.312-21.114 0-3.497-.627-6.76-2.194-9.667l3.938-9.254 7.338 7.262c-.11.881-.177 1.791-.177 2.701 0 12.234 10.443 22.116 23.347 22.116 11.506 0 21.69-7.554 23.189-18.72.32.154.235-8.325 1.049-8.411.968-.1 2.874 8.143 3.195 7.908 3.051 8.867 11.865 15.285 22.264 15.285 12.91 0 23.366-9.934 23.366-22.144 0-2.74-.162-5.34-1.125-7.722l6.102-1.082"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#fff"
            d="M615.18 245.27c1.35-3.967.143-7.89-2.711-8.747-2.85-.896-6.28 1.605-7.63 5.556-1.361 3.952-.144 7.856 2.71 8.752 2.85.857 6.275-1.624 7.63-5.562M513.49 225.573c.533-4.139-1.446-7.75-4.425-8.09-2.98-.355-5.835 2.701-6.366 6.825-.537 4.12 1.442 7.755 4.421 8.11 2.98.335 5.834-2.721 6.37-6.845m-118.07 0c-.532-4.139 1.465-7.75 4.426-8.09 2.98-.355 5.834 2.701 6.37 6.825.513 4.12-1.446 7.755-4.426 8.11-2.979.335-5.834-2.721-6.37-6.845M293.75 245.27c-1.356-3.967-.144-7.89 2.71-8.747 2.856-.896 6.262 1.605 7.617 5.556 1.337 3.952.125 7.856-2.711 8.752-2.855.857-6.26-1.624-7.616-5.562"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g fill="#9f7e00">
            <path
              d="M340.056 225.98c-1.605-1.27-2.817-3.042-3.21-5.135-.397-2.079.053-4.139 1.107-5.83 0 0-4.216-2.126-8.728-3.31-3.425-.895-9.45-.929-11.27-.962-1.821-.053-5.457-.134-5.457-.134s.302.828 1.337 2.634c1.245 2.18 2.352 3.545 2.352 3.545-6.031 1.389-11.166 5.355-14.414 9.954 4.714 3.257 10.974 5.235 17.125 4.608 0 0-.537 1.643-.925 4.124-.32 2.045-.302 2.888-.302 2.888s3.387-1.25 5.083-1.873c1.695-.627 7.348-2.586 10.255-4.545 3.799-2.601 7.047-5.95 7.047-5.95m13.522-2.28c1.05-1.686 1.552-3.75 1.16-5.844-.394-2.093-1.538-3.865-3.143-5.135 0 0 3.176-3.362 6.974-5.944 2.894-1.96 8.56-3.937 10.256-4.546 1.696-.622 5.087-1.892 5.087-1.892s.015.862-.306 2.908c-.388 2.467-.93 4.105-.93 4.105 6.16-.642 12.43 1.418 17.144 4.694-3.243 4.58-8.416 8.478-14.428 9.868 0 0 1.088 1.365 2.352 3.544 1.035 1.825 1.341 2.635 1.341 2.635s-3.64-.082-5.46-.115c-1.82-.034-7.847-.053-11.271-.963-4.513-1.202-8.776-3.296-8.776-3.296"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="M348.881 191.841s.613-1.216 3.387-2.821c2.783-1.571 5.178-1.523 5.178-1.523s-.805 4.612-1.217 6.27c-.412 1.619-.426 6.572-1.494 11.031-1.073 4.46-3.013 8.024-3.013 8.024a9.48 9.48 0 0 0-7.497-1.979c-2.778.475-5.03 2.113-6.332 4.273 0 0-3.104-2.716-5.73-6.553-2.6-3.837-4.401-8.464-5.364-9.867-.982-1.418-3.41-5.504-3.41-5.504s2.232-.829 5.422-.24c3.195.595 4.196 1.557 4.196 1.557-.714-6.097 1.322-12.468 4.905-17.095 5.03 3.19 9.432 8.497 10.97 14.427z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
          </g>
          <path
            fill="#b50027"
            d="M335.649 219.274c0-5.408 4.622-9.781 10.313-9.781 5.667 0 10.308 4.373 10.308 9.78 0 5.39-4.622 9.763-10.308 9.763-5.69 0-10.313-4.373-10.313-9.762"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g fill="#9f7e00">
            <path
              d="M463.44 179.914s.89-1.25 4.334-2.5c3.44-1.25 6.079-.762 6.079-.762s-1.835 5.02-2.64 6.773c-.8 1.758-1.834 7.267-3.98 12.014-2.084 4.78-4.991 8.377-4.991 8.377-1.893-2.16-4.743-3.563-7.957-3.563-3.195 0-6.045 1.403-7.937 3.563 0 0-2.908-3.597-5.01-8.377-2.127-4.747-3.176-10.256-3.962-12.014-.8-1.753-2.658-6.773-2.658-6.773s2.658-.489 6.083.762c3.44 1.25 4.354 2.5 4.354 2.5.48-6.912 4.086-13.632 9.025-18.126 4.958 4.494 8.775 11.214 9.26 18.126z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="M446.492 216.333c-1.533-1.705-2.515-3.918-2.515-6.318 0-2.381.91-4.608 2.443-6.285 0 0-4.244-3.176-9.025-5.336-3.621-1.657-10.346-2.802-12.363-3.176-2.031-.388-6.064-1.15-6.064-1.15s.163.963.943 3.176c.949 2.688 1.893 4.412 1.893 4.412-6.99.422-13.576 3.9-18.14 8.411 4.564 4.474 11.132 7.87 18.14 8.33 0 0-.944 1.706-1.893 4.407-.78 2.18-.943 3.157-.943 3.157s4.033-.743 6.064-1.112c2.017-.407 8.742-1.537 12.363-3.209 4.78-2.165 9.097-5.288 9.097-5.288m15.538-.019c1.534-1.705 2.51-3.918 2.51-6.318a9.295 9.295 0 0 0-2.442-6.285s4.249-3.176 9.03-5.336c3.635-1.657 10.36-2.802 12.377-3.176 1.997-.388 6.026-1.15 6.026-1.15s-.14.963-.944 3.176c-.948 2.688-1.873 4.412-1.873 4.412 6.994.422 13.57 3.9 18.121 8.411-4.55 4.474-11.113 7.87-18.12 8.33 0 0 .924 1.706 1.872 4.407.786 2.18.944 3.157.944 3.157s-4.01-.743-6.026-1.112c-2.017-.407-8.742-1.537-12.378-3.209-4.78-2.165-9.096-5.288-9.096-5.288m97.996-24.511s-.613-1.216-3.387-2.821c-2.783-1.571-5.178-1.523-5.178-1.523s.805 4.612 1.217 6.27c.412 1.619.426 6.572 1.494 11.031 1.073 4.46 3.013 8.024 3.013 8.024a9.48 9.48 0 0 1 7.497-1.979c2.778.475 5.03 2.113 6.332 4.273 0 0 3.104-2.716 5.73-6.553 2.6-3.837 4.401-8.464 5.364-9.867.982-1.418 3.41-5.504 3.41-5.504s-2.232-.829-5.422-.24c-3.195.595-4.196 1.557-4.196 1.557.714-6.097-1.322-12.468-4.905-17.095-5.03 3.19-9.432 8.497-10.97 14.427z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="M568.874 225.98c1.59-1.27 2.821-3.042 3.19-5.135a8.134 8.134 0 0 0-1.082-5.83s4.191-2.126 8.698-3.31c3.43-.895 9.475-.929 11.272-.962 1.825-.053 5.46-.134 5.46-.134s-.287.828-1.331 2.634c-1.255 2.18-2.357 3.545-2.357 3.545 6.026 1.389 11.16 5.355 14.413 9.954-4.694 3.257-10.955 5.235-17.124 4.608 0 0 .55 1.643.929 4.124.297 2.045.283 2.888.283 2.888s-3.392-1.25-5.064-1.873c-1.695-.627-7.352-2.586-10.26-4.545-3.78-2.601-7.027-5.95-7.027-5.95m-13.537-2.28c-1.054-1.686-1.533-3.75-1.164-5.844.398-2.093 1.557-3.865 3.157-5.135 0 0-3.19-3.362-6.989-5.944-2.888-1.96-8.565-3.937-10.256-4.546-1.695-.622-5.067-1.892-5.067-1.892s-.015.862.301 2.908c.379 2.467.915 4.105.915 4.105-6.155-.642-12.435 1.418-17.13 4.694 3.253 4.58 8.407 8.478 14.419 9.868 0 0-1.088 1.365-2.343 3.544-1.049 1.825-1.331 2.635-1.331 2.635s3.616-.082 5.437-.115c1.8-.034 7.87-.053 11.27-.963 4.499-1.202 8.762-3.296 8.762-3.296"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
          </g>
          <path
            fill="#b50027"
            d="M552.645 219.274c0-5.408 4.613-9.781 10.308-9.781 5.71 0 10.328 4.373 10.328 9.78 0 5.39-4.618 9.763-10.328 9.763-5.695 0-10.308-4.373-10.308-9.762m115.317 21.689c-2.429-2.567-7.458-2.026-11.218 1.183-3.765 3.19-4.858 7.89-2.429 10.438 2.429 2.567 7.458 2.012 11.218-1.178 3.765-3.229 4.858-7.909 2.43-10.443"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="M653.319 247.18c.517-1.757 1.695-3.549 3.425-5.034 3.76-3.209 8.79-3.75 11.218-1.183.302.34.642.795.838 1.198 0 0 5.226-9.916 11.415-13.206 6.194-3.33 16.665-2.486 16.665-2.486 0-7.602-6.227-13.748-14.255-13.748-4.71 0-9.169 1.96-11.794 5.27l-1.082-5.102s-6.457 1.283-9.422 8.665c-2.941 7.4.268 18.092.268 18.092s-1.605-4.594-4.028-7.655c-2.41-3.036-8.599-6.366-11.827-7.884-3.229-1.504-6.529-3.77-6.529-3.77s-.144.829-.269 2.874c-.124 2.448.072 3.952.072 3.952-5.92-.776-12.827.187-18.212 2.28 2.3 4.527 6.687 8.785 12.43 10.965 0 0-2.069 1.705-3.96 3.578-1.567 1.59-2.065 2.332-2.065 2.332l6.083.863c2.012.268 8.737 1.331 12.752 1.063 2.96-.187 6.28-.675 8.277-1.063m-397.722-.001c-.518-1.757-1.687-3.549-3.425-5.034-3.765-3.209-8.78-3.75-11.224-1.183a5.23 5.23 0 0 0-.838 1.198s-5.245-9.916-11.434-13.206c-6.17-3.33-16.64-2.486-16.64-2.486 0-7.602 6.226-13.748 14.25-13.748 4.728 0 9.154 1.96 11.808 5.27l1.073-5.102s6.457 1.283 9.417 8.665c2.955 7.4-.268 18.092-.268 18.092s1.604-4.594 4.033-7.655c2.424-3.036 8.612-6.366 11.836-7.884 3.22-1.504 6.534-3.77 6.534-3.77s.124.829.254 2.874c.124 2.448-.072 3.952-.072 3.952 5.901-.776 12.823.187 18.212 2.28-2.304 4.527-6.677 8.785-12.435 10.965 0 0 2.07 1.705 3.956 3.578 1.576 1.59 2.089 2.332 2.089 2.332s-4.067.575-6.079.863c-2.04.268-8.742 1.331-12.756 1.063-2.96-.187-6.28-.675-8.291-1.063"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M240.948 240.963c2.443-2.567 7.459-2.026 11.224 1.183 3.779 3.19 4.847 7.89 2.423 10.438-2.423 2.567-7.458 2.012-11.218-1.178-3.765-3.229-4.852-7.909-2.429-10.443m203.029-30.948c0-5.403 4.618-9.762 10.308-9.762s10.328 4.359 10.328 9.762c0 5.408-4.618 9.781-10.328 9.781-5.69 0-10.308-4.373-10.308-9.781"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <g strokeWidth={1.231}>
          <path
            fill="#0044ad"
            d="M432.826 61.58c0-11.05 9.44-19.97 21.066-19.97 11.63 0 21.067 8.92 21.067 19.97 0 11.013-9.436 19.932-21.067 19.932-11.625 0-21.066-8.92-21.066-19.931"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="M448.375 5.616v10.777h-11.526V27.32h11.526v31.435h-14.52c-.171 1.025-1.048 1.773-1.048 2.844 0 2.753.58 5.4 1.647 7.784.029.064.12.086.15.15h38.62c.03-.064.12-.086.15-.15a19.053 19.053 0 0 0 1.646-7.784c0-1.067-.88-1.821-1.048-2.844H459.9V27.32h11.526V16.393H459.9V5.616z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path
        fill="#fff"
        d="M298.181 195.701c0-.608.476-1.092 1.062-1.092.588 0 1.06.484 1.06 1.092 0 .608-.472 1.095-1.06 1.095-.586 0-1.062-.487-1.062-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M685.326 210.829c0-2.74 2.276-4.92 5.075-4.92 2.813 0 5.07 2.18 5.07 4.92 0 2.735-2.257 4.929-5.07 4.929-2.8 0-5.075-2.194-5.075-4.929z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M299.634 192.896c0-.604.473-1.093 1.062-1.093.584 0 1.06.489 1.06 1.093 0 .611-.476 1.098-1.06 1.098-.589 0-1.062-.487-1.062-1.098"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M692.271 198.193c0-2.72 2.262-4.92 5.076-4.92 2.793 0 5.07 2.2 5.07 4.92 0 2.754-2.277 4.948-5.07 4.948-2.814 0-5.076-2.194-5.076-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M300.6 189.648c0-.604.477-1.096 1.067-1.096.584 0 1.06.491 1.06 1.096 0 .607-.476 1.098-1.06 1.098-.59 0-1.067-.491-1.067-1.098"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M696.89 183.564c0-2.72 2.28-4.934 5.098-4.934 2.794 0 5.07 2.213 5.07 4.934 0 2.735-2.277 4.948-5.07 4.948-2.818 0-5.1-2.213-5.1-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M300.725 186.162c0-.607.475-1.094 1.06-1.094.585 0 1.061.487 1.061 1.094 0 .609-.476 1.096-1.062 1.096-.584 0-1.06-.487-1.06-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M697.486 167.867c0-2.735 2.272-4.929 5.065-4.929 2.8 0 5.076 2.194 5.076 4.929 0 2.74-2.277 4.934-5.076 4.934-2.793 0-5.065-2.194-5.065-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M299.936 182.731c0-.604.477-1.092 1.06-1.092.59 0 1.066.488 1.066 1.092 0 .61-.477 1.099-1.066 1.099-.583 0-1.06-.488-1.06-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M693.717 152.414c0-2.72 2.277-4.92 5.066-4.92 2.817 0 5.093 2.2 5.093 4.92 0 2.75-2.276 4.948-5.093 4.948-2.789 0-5.066-2.198-5.066-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M298.301 179.617c0-.607.476-1.094 1.062-1.094.588 0 1.062.487 1.062 1.094 0 .608-.474 1.1-1.062 1.1-.586 0-1.062-.492-1.062-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M685.9 138.39c0-2.736 2.275-4.93 5.074-4.93 2.813 0 5.08 2.194 5.08 4.929 0 2.74-2.267 4.953-5.08 4.953-2.799 0-5.074-2.213-5.074-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M296.121 177.06c0-.608.475-1.1 1.06-1.1.59 0 1.065.492 1.065 1.1 0 .603-.475 1.095-1.064 1.095-.586 0-1.06-.492-1.06-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M675.48 126.869c0-2.735 2.27-4.948 5.069-4.948 2.818 0 5.089 2.213 5.089 4.948 0 2.72-2.271 4.934-5.09 4.934-2.798 0-5.069-2.213-5.069-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M293.588 174.933c0-.608.476-1.1 1.066-1.1.584 0 1.06.492 1.06 1.1 0 .603-.476 1.095-1.06 1.095-.59 0-1.066-.492-1.066-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M663.37 117.294c0-2.74 2.276-4.953 5.093-4.953 2.795 0 5.07 2.213 5.07 4.953 0 2.716-2.275 4.929-5.07 4.929-2.817 0-5.093-2.213-5.093-4.93z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M290.562 173.192c0-.607.475-1.091 1.06-1.091.59 0 1.065.484 1.065 1.091 0 .608-.476 1.1-1.064 1.1-.586 0-1.06-.492-1.06-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M648.905 109.452c0-2.735 2.271-4.914 5.07-4.914 2.813 0 5.09 2.18 5.09 4.914 0 2.74-2.277 4.953-5.09 4.953-2.799 0-5.07-2.213-5.07-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M287.422 171.95c0-.603.476-1.094 1.065-1.094.585 0 1.062.49 1.062 1.095 0 .607-.478 1.098-1.062 1.098-.589 0-1.065-.49-1.065-1.098"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.845}
        d="M675.248 192.818c6.829-7.855 11.013-18.005 11.013-29.104a41.488 42.605 0 0 0-4.236-18.8c-9.864-20.847-40.82-36.017-77.608-36.017-10.024 0-19.615 1.116-28.472 3.19 1.964 2.199 3.507 4.613 5.01 7.046 7.36-1.47 15.243-2.266 23.462-2.266 33.678 0 61.852 13.45 70.015 31.624a34.076 34.993 0 0 1 3.391 15.223c0 11.046-5.038 20.947-12.926 27.706l12.194 20.453 6.53-5.336-8.373-13.7v-.018z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M633.895 103.862c0-2.72 2.275-4.933 5.089-4.933 2.794 0 5.075 2.213 5.075 4.933 0 2.735-2.282 4.948-5.075 4.948-2.814 0-5.09-2.213-5.09-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M283.913 171.268c0-.604.475-1.099 1.06-1.099.59 0 1.064.495 1.064 1.1 0 .603-.474 1.095-1.064 1.095-.585 0-1.06-.492-1.06-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M617.116 100.787c0-2.72 2.272-4.948 5.07-4.948 2.818 0 5.085 2.227 5.085 4.948 0 2.72-2.267 4.934-5.084 4.934-2.799 0-5.07-2.213-5.07-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M280.58 171.077c0-.604.476-1.092 1.065-1.092.585 0 1.061.488 1.061 1.092 0 .608-.476 1.1-1.061 1.1-.589 0-1.065-.492-1.065-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M601.186 99.925c0-2.72 2.277-4.915 5.09-4.915 2.799 0 5.074 2.194 5.074 4.915 0 2.74-2.275 4.953-5.074 4.953-2.813 0-5.089-2.213-5.089-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M277.31 171.201c0-.604.477-1.095 1.064-1.095.59 0 1.062.491 1.062 1.095 0 .607-.472 1.099-1.062 1.099-.587 0-1.065-.492-1.065-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M585.55 100.485c0-2.72 2.283-4.933 5.09-4.933 2.818 0 5.075 2.213 5.075 4.933 0 2.735-2.257 4.948-5.075 4.948-2.807 0-5.09-2.213-5.09-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M274.044 171.201c0-.604.475-1.095 1.06-1.095.585 0 1.06.491 1.06 1.095 0 .607-.475 1.099-1.06 1.099-.585 0-1.06-.492-1.06-1.099"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeWidth={1.857}
          d="M573.032 100.485c0-2.72 2.333-4.933 5.207-4.933 2.869 0 5.206 2.213 5.206 4.933 0 2.735-2.337 4.948-5.206 4.948-2.874 0-5.207-2.213-5.207-4.948z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#fff"
          strokeWidth={1.859}
          d="M581.06 114.252c0-2.735 2.338-4.948 5.207-4.948 2.888 0 5.207 2.213 5.207 4.948 0 2.72-2.319 4.948-5.207 4.948-2.87 0-5.207-2.227-5.207-4.948m3.262 15.204c0-2.736 2.338-4.953 5.212-4.953 2.888 0 5.226 2.217 5.226 4.953 0 2.701-2.338 4.914-5.226 4.914-2.874 0-5.212-2.213-5.212-4.914m.589 15.151c0-2.755 2.338-4.949 5.226-4.949 2.874 0 5.202 2.194 5.202 4.949 0 2.72-2.328 4.933-5.202 4.933-2.888 0-5.226-2.213-5.226-4.933m-4.747 13.785c0-2.72 2.338-4.948 5.207-4.948 2.893 0 5.212 2.228 5.212 4.948 0 2.735-2.319 4.934-5.212 4.934-2.87 0-5.207-2.199-5.207-4.934m-8.866 12.67c0-2.72 2.342-4.948 5.211-4.948 2.884 0 5.207 2.227 5.207 4.948 0 2.72-2.323 4.934-5.207 4.934-2.869 0-5.211-2.213-5.211-4.934"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#fff"
        d="M271.57 169.078c0-.604.475-1.092 1.064-1.092.585 0 1.06.488 1.06 1.092 0 .608-.475 1.099-1.06 1.099-.589 0-1.065-.491-1.065-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M558.11 90.924c0-2.72 2.276-4.919 5.089-4.919 2.798 0 5.07 2.199 5.07 4.92 0 2.735-2.272 4.948-5.07 4.948-2.813 0-5.09-2.213-5.09-4.949z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M268.665 167.33c0-.604.473-1.099 1.062-1.099.585 0 1.06.495 1.06 1.099s-.475 1.095-1.06 1.095c-.589 0-1.062-.491-1.062-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M544.228 83.05c0-2.721 2.262-4.949 5.075-4.949 2.798 0 5.065 2.228 5.065 4.949s-2.267 4.933-5.065 4.933c-2.813 0-5.075-2.213-5.075-4.933z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M265.465 166.276c0-.604.476-1.091 1.063-1.091.586 0 1.062.487 1.062 1.09 0 .608-.476 1.1-1.062 1.1-.587 0-1.063-.492-1.063-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M528.928 78.303c0-2.721 2.277-4.915 5.084-4.915 2.8 0 5.076 2.194 5.076 4.915 0 2.735-2.276 4.953-5.076 4.953-2.807 0-5.083-2.218-5.083-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M262.136 165.653c0-.603.477-1.095 1.061-1.095.588 0 1.062.492 1.062 1.095 0 .604-.474 1.096-1.062 1.096-.585 0-1.06-.492-1.06-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M513.017 75.5c0-2.72 2.277-4.933 5.07-4.933 2.813 0 5.076 2.213 5.076 4.933 0 2.716-2.263 4.934-5.075 4.934-2.795 0-5.07-2.218-5.07-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M258.878 165.713c0-.604.475-1.098 1.06-1.098.588 0 1.065.494 1.065 1.098 0 .609-.477 1.095-1.065 1.095-.585 0-1.06-.486-1.06-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M497.439 75.769c0-2.721 2.27-4.948 5.07-4.948 2.813 0 5.088 2.227 5.088 4.948 0 2.74-2.275 4.933-5.089 4.933-2.798 0-5.07-2.193-5.07-4.933z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M255.487 166.336c0-.604.476-1.092 1.061-1.092.589 0 1.065.488 1.065 1.092 0 .611-.476 1.1-1.065 1.1-.585 0-1.061-.49-1.061-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M481.23 78.576c0-2.721 2.275-4.92 5.074-4.92 2.813 0 5.089 2.199 5.089 4.92 0 2.75-2.276 4.948-5.09 4.948-2.798 0-5.074-2.199-5.074-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M252.348 167.518c0-.608.476-1.1 1.06-1.1.589 0 1.065.492 1.065 1.1 0 .603-.476 1.099-1.065 1.099-.584 0-1.06-.496-1.06-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M466.223 83.897c0-2.74 2.276-4.952 5.07-4.952 2.813 0 5.09 2.213 5.09 4.952 0 2.716-2.277 4.949-5.09 4.949-2.794 0-5.07-2.233-5.07-4.949z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M199.177 195.701c0-.608.476-1.092 1.06-1.092.59 0 1.063.484 1.063 1.092 0 .608-.473 1.095-1.062 1.095-.585 0-1.06-.487-1.06-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M212.047 210.829c0-2.74 2.277-4.92 5.07-4.92 2.819 0 5.076 2.18 5.076 4.92 0 2.735-2.257 4.929-5.075 4.929-2.794 0-5.07-2.194-5.07-4.929z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M197.724 192.896c0-.604.476-1.093 1.06-1.093.59 0 1.066.489 1.066 1.093 0 .611-.477 1.098-1.065 1.098-.585 0-1.062-.487-1.062-1.098"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M205.098 198.193c0-2.72 2.276-4.92 5.074-4.92 2.814 0 5.09 2.2 5.09 4.92 0 2.754-2.277 4.948-5.09 4.948-2.798 0-5.075-2.194-5.075-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M196.754 189.648c0-.604.476-1.096 1.064-1.096.586 0 1.062.491 1.062 1.096 0 .607-.476 1.098-1.062 1.098-.588 0-1.064-.491-1.064-1.098"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M200.461 183.564c0-2.72 2.276-4.934 5.089-4.934 2.799 0 5.074 2.213 5.074 4.934 0 2.735-2.275 4.948-5.074 4.948-2.813 0-5.089-2.213-5.089-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M196.634 186.162c0-.607.476-1.094 1.061-1.094.589 0 1.065.487 1.065 1.094 0 .609-.476 1.096-1.065 1.096-.585 0-1.061-.487-1.061-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M199.887 167.867c0-2.735 2.276-4.929 5.075-4.929 2.813 0 5.089 2.194 5.089 4.929 0 2.74-2.276 4.934-5.09 4.934-2.798 0-5.074-2.194-5.074-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M197.422 182.731c0-.604.476-1.092 1.06-1.092.586 0 1.062.488 1.062 1.092 0 .61-.476 1.099-1.061 1.099s-1.061-.488-1.061-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M203.657 152.414c0-2.72 2.276-4.92 5.07-4.92 2.798 0 5.075 2.2 5.075 4.92 0 2.75-2.277 4.948-5.076 4.948-2.794 0-5.07-2.198-5.07-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M199.053 179.617c0-.607.477-1.094 1.066-1.094.584 0 1.06.487 1.06 1.094 0 .608-.476 1.1-1.06 1.1-.59 0-1.065-.492-1.065-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M211.455 138.39c0-2.736 2.277-4.93 5.093-4.93 2.795 0 5.071 2.194 5.071 4.929 0 2.74-2.276 4.953-5.07 4.953-2.817 0-5.093-2.213-5.093-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M201.234 177.06c0-.608.476-1.1 1.065-1.1.584 0 1.06.492 1.06 1.1 0 .603-.476 1.095-1.06 1.095-.589 0-1.065-.492-1.065-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M221.88 126.869c0-2.735 2.277-4.948 5.09-4.948 2.794 0 5.07 2.213 5.07 4.948 0 2.72-2.277 4.934-5.07 4.934-2.813 0-5.09-2.213-5.09-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M203.766 174.933c0-.608.476-1.1 1.065-1.1.585 0 1.061.492 1.061 1.1 0 .603-.476 1.095-1.061 1.095-.589 0-1.065-.492-1.065-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M233.985 117.294c0-2.74 2.276-4.953 5.089-4.953 2.798 0 5.075 2.213 5.075 4.953 0 2.716-2.277 4.929-5.075 4.929-2.813 0-5.09-2.213-5.09-4.93z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M206.793 173.192c0-.607.476-1.091 1.065-1.091.585 0 1.061.484 1.061 1.091 0 .608-.476 1.1-1.061 1.1-.589 0-1.065-.492-1.065-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M248.454 109.452c0-2.735 2.277-4.914 5.09-4.914 2.798 0 5.074 2.18 5.074 4.914 0 2.74-2.276 4.953-5.075 4.953-2.812 0-5.089-2.213-5.089-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M209.933 171.95c0-.603.475-1.094 1.06-1.094.59 0 1.065.49 1.065 1.095 0 .607-.476 1.098-1.064 1.098-.586 0-1.06-.49-1.06-1.098"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M263.465 103.862c0-2.72 2.272-4.933 5.07-4.933 2.813 0 5.09 2.213 5.09 4.933 0 2.735-2.277 4.948-5.09 4.948-2.798 0-5.07-2.213-5.07-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M213.447 171.268c0-.604.475-1.099 1.06-1.099.585 0 1.061.495 1.061 1.1 0 .603-.476 1.095-1.06 1.095-.586 0-1.061-.492-1.061-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M280.262 100.787c0-2.72 2.272-4.948 5.07-4.948 2.794 0 5.07 2.227 5.07 4.948 0 2.72-2.276 4.934-5.07 4.934-2.798 0-5.07-2.213-5.07-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M216.775 171.077c0-.604.475-1.092 1.065-1.092.584 0 1.06.488 1.06 1.092 0 .608-.476 1.1-1.06 1.1-.59 0-1.065-.492-1.065-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M296.173 99.925c0-2.72 2.271-4.915 5.089-4.915 2.794 0 5.07 2.194 5.07 4.915 0 2.74-2.277 4.953-5.07 4.953-2.818 0-5.09-2.213-5.09-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M220.044 171.201c0-.604.477-1.095 1.062-1.095.589 0 1.064.491 1.064 1.095 0 .607-.475 1.099-1.064 1.099-.585 0-1.062-.492-1.062-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M311.799 100.485c0-2.72 2.28-4.933 5.074-4.933 2.818 0 5.09 2.213 5.09 4.933 0 2.735-2.272 4.948-5.09 4.948-2.793 0-5.074-2.213-5.074-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M223.315 171.201c0-.604.476-1.095 1.061-1.095.589 0 1.065.491 1.065 1.095 0 .607-.476 1.099-1.065 1.099-.585 0-1.061-.492-1.061-1.099"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeWidth={1.857}
          d="M324 100.485c0-2.72 2.337-4.933 5.21-4.933 2.89 0 5.227 2.213 5.227 4.933 0 2.735-2.338 4.948-5.226 4.948-2.874 0-5.212-2.213-5.212-4.948z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          strokeWidth={1.857}
          d="M336.717 176.499c-12.521-9.34-20.296-22.044-20.296-36.031 0-16.114 10.538-30.489 26.557-40.016-9.882 7.937-15.875 18.192-16.732 29.645a43.66 43.66 0 0 0-.216 4.34c0 13.163 6.017 25.019 15.52 33.262l-4.833 8.8"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#fff"
          strokeWidth={1.859}
          d="M315.976 114.252c0-2.735 2.333-4.948 5.207-4.948 2.888 0 5.226 2.213 5.226 4.948 0 2.72-2.338 4.948-5.226 4.948-2.874 0-5.207-2.227-5.207-4.948m-3.267 15.204c0-2.736 2.318-4.953 5.212-4.953 2.869 0 5.206 2.217 5.206 4.953 0 2.701-2.337 4.914-5.206 4.914-2.894 0-5.212-2.213-5.212-4.914m-.604 15.151c0-2.755 2.338-4.949 5.226-4.949 2.87 0 5.207 2.194 5.207 4.949 0 2.72-2.337 4.933-5.207 4.933-2.888 0-5.226-2.213-5.226-4.933m4.762 13.785c0-2.72 2.337-4.948 5.207-4.948 2.893 0 5.226 2.228 5.226 4.948 0 2.735-2.333 4.934-5.226 4.934-2.87 0-5.207-2.199-5.207-4.934m8.861 12.67c0-2.72 2.343-4.948 5.207-4.948 2.893 0 5.231 2.227 5.231 4.948 0 2.72-2.338 4.934-5.23 4.934-2.865 0-5.208-2.213-5.208-4.934"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#fff"
        d="M225.786 169.078c0-.604.476-1.092 1.06-1.092.59 0 1.065.488 1.065 1.092 0 .608-.476 1.099-1.064 1.099-.585 0-1.06-.491-1.06-1.099"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M339.25 90.924c0-2.72 2.276-4.919 5.07-4.919 2.813 0 5.089 2.199 5.089 4.92 0 2.735-2.276 4.948-5.09 4.948-2.793 0-5.069-2.213-5.069-4.949z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M228.693 167.33c0-.604.476-1.099 1.06-1.099.59 0 1.065.495 1.065 1.099s-.476 1.095-1.064 1.095c-.585 0-1.06-.491-1.06-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M353.145 83.05c0-2.721 2.277-4.949 5.07-4.949 2.814 0 5.09 2.228 5.09 4.949s-2.276 4.933-5.09 4.933c-2.794 0-5.07-2.213-5.07-4.933z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M231.89 166.276c0-.604.477-1.091 1.064-1.091.586 0 1.062.487 1.062 1.09 0 .608-.476 1.1-1.062 1.1-.587 0-1.064-.492-1.064-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M368.427 78.303c0-2.721 2.28-4.915 5.089-4.915 2.798 0 5.074 2.194 5.074 4.915 0 2.735-2.276 4.953-5.074 4.953-2.809 0-5.09-2.218-5.09-4.953z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M235.221 165.653c0-.603.477-1.095 1.062-1.095.589 0 1.065.492 1.065 1.095 0 .604-.476 1.096-1.065 1.096-.585 0-1.062-.492-1.062-1.096"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M384.35 75.5c0-2.72 2.282-4.933 5.076-4.933 2.817 0 5.093 2.213 5.093 4.933 0 2.716-2.276 4.934-5.093 4.934-2.794 0-5.075-2.218-5.075-4.934z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M238.482 165.713c0-.604.471-1.098 1.06-1.098.585 0 1.061.494 1.061 1.098 0 .609-.476 1.095-1.06 1.095-.59 0-1.06-.486-1.06-1.095"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M399.94 75.769c0-2.721 2.253-4.948 5.07-4.948 2.795 0 5.07 2.227 5.07 4.948 0 2.74-2.275 4.933-5.07 4.933-2.817 0-5.07-2.193-5.07-4.933z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M241.872 166.336c0-.604.476-1.092 1.06-1.092.59 0 1.062.488 1.062 1.092 0 .611-.472 1.1-1.062 1.1-.584 0-1.06-.49-1.06-1.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.845}
        d="M416.144 78.576c0-2.721 2.277-4.92 5.07-4.92 2.818 0 5.076 2.199 5.076 4.92 0 2.75-2.258 4.948-5.075 4.948-2.795 0-5.07-2.199-5.07-4.948z"
        transform="matrix(.20919 0 0 .22204 154.82 148.89)"
      />
      <path
        fill="#fff"
        d="M245.008 167.518c0-.608.475-1.1 1.063-1.1.586 0 1.062.492 1.062 1.1 0 .603-.476 1.099-1.062 1.099-.588 0-1.063-.496-1.063-1.1"
      />
      <g stroke="#000" strokeWidth={1.857}>
        <path
          fill="none"
          d="M430.493 83.897c0-2.74 2.333-4.952 5.221-4.952 2.874 0 5.212 2.213 5.212 4.952 0 2.716-2.338 4.949-5.212 4.949-2.888 0-5.221-2.233-5.221-4.949z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M239.095 124.287c-9.097 5.724-15.985 12.77-19.783 20.626a42.605 42.605 0 0 0-4.35 18.801c0 11.099 4.297 21.249 11.31 29.104l-7.602 12.335c-7.277-9.346-11.506-20.257-11.506-31.864 0-19.984 12.718-37.448 31.93-49.002zm429.26 0c9.096 5.724 15.984 12.77 19.802 20.626a43.118 43.118 0 0 1 4.326 18.801c0 11.099-4.292 21.249-11.286 29.104l7.583 12.335c7.276-9.346 11.486-20.257 11.486-31.864 0-19.984-12.698-37.448-31.911-49.002z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#b50027"
        d="M322.34 218.63s-.713.818-1.233.934c-.519.113-1.177-.51-1.177-.51s-.468.533-1.043.675c-.574.143-1.37-.705-1.37-.705s-.548.848-1.04 1.047c-.493.198-1.093-.255-1.093-.255s-.217.42-.628.652c-.175.09-.465-.06-.465-.06l-.58-.394-.657-.765-.602-.255s-.272-.96-.301-1.128l-.08-.597c-.124-.686.847-1.481 2.23-1.823.796-.202 1.49-.187 2-.015.552-.514 1.722-.87 3.098-.87 1.246 0 2.34.289 2.944.735.596-.446 1.69-.735 2.94-.735 1.37 0 2.538.356 3.092.87.512-.172 1.202-.184 2.002.015 1.38.342 2.354 1.137 2.23 1.823 0 0-.058.428-.083.597-.029.168-.301 1.128-.301 1.128l-.604.256-.658.764-.57.395s-.29.15-.465.06c-.41-.23-.632-.653-.632-.653s-.603.453-1.094.255c-.494-.2-1.042-1.047-1.042-1.047s-.793.848-1.371.705c-.574-.142-1.04-.674-1.04-.674s-.658.622-1.176.51c-.523-.117-1.228-.935-1.228-.935"
      />
      <g stroke="#000">
        <path
          fill="none"
          d="M810.12 314.096s-3.496 3.684-6.05 4.206c-2.548.508-5.776-2.294-5.776-2.294s-2.3 2.395-5.121 3.036c-2.817.642-6.73-3.175-6.73-3.175s-2.687 3.817-5.102 4.713c-2.419.896-5.365-1.145-5.365-1.145s-1.068 1.892-3.084 2.937c-.858.407-2.28-.269-2.28-.269l-2.846-1.777-3.228-3.444-2.956-1.15s-1.336-4.325-1.48-5.082c-.105-.761-.393-2.687-.393-2.687-.604-3.09 4.158-6.672 10.95-8.21 3.909-.91 7.31-.843 9.815-.067 2.711-2.314 8.455-3.918 15.213-3.918 6.117 0 11.487 1.298 14.452 3.31 2.922-2.012 8.292-3.31 14.428-3.31 6.725 0 12.464 1.604 15.18 3.918 2.515-.776 5.901-.829 9.83.067 6.772 1.538 11.558 5.12 10.944 8.21 0 0-.282 1.926-.402 2.687-.144.757-1.48 5.083-1.48 5.083l-2.965 1.15-3.229 3.443-2.797 1.777s-1.428.676-2.285.269c-2.017-1.03-3.104-2.937-3.104-2.937s-2.96 2.04-5.37 1.145c-2.424-.896-5.116-4.713-5.116-4.713s-3.89 3.817-6.73 3.175c-2.816-.641-5.106-3.036-5.106-3.036s-3.228 2.802-5.772 2.294c-2.567-.522-6.026-4.206-6.026-4.206h-.02z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="M803.467 293.992c0-5.149 2.927-9.321 6.543-9.321 3.621 0 6.567 4.172 6.567 9.321 0 5.174-2.946 9.36-6.567 9.36-3.616 0-6.543-4.186-6.543-9.36z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M807.122 293.992c0-4.727 1.355-8.579 3.017-8.579 1.672 0 3.013 3.852 3.013 8.58 0 4.746-1.34 8.602-3.013 8.602-1.662 0-3.017-3.856-3.017-8.603z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <g strokeWidth={0.987}>
        <path
          fill="#9f7e00"
          d="M315.46 222.674c-.196-.604-.564-1.144-.564-1.144 1.887-.604 4.514-.983 7.436-.99 2.921.007 5.567.386 7.453.99l-.506.968c-.163.311-.377.855-.363.855-1.705-.57-3.9-.863-6.595-.866-2.7.003-5.294.364-6.647.903.02 0-.094-.34-.228-.716h.014"
        />
        <path
          fill="none"
          stroke="#000"
          d="M767.928 332.308c-.938-2.72-2.697-5.154-2.697-5.154 9.021-2.72 21.58-4.426 35.544-4.46 13.967.034 26.612 1.74 35.628 4.46 0 0-1.007 1.825-2.416 4.359-.58.96-.713 1.415-1.735 3.851-8.15-2.567-18.64-3.885-31.528-3.899-12.907.015-25.309 1.638-31.775 4.067.094 0-.448-1.533-1.09-3.224h.069"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M322.332 225.288c2.357-.004 4.953-.393 5.912-.663.639-.203 1.014-.518.944-.882-.032-.172-.17-.322-.357-.408-1.406-.492-3.94-.84-6.5-.845-2.553.004-5.1.353-6.512.845-.18.086-.323.236-.352.408-.072.364.303.679.946.882.956.27 3.563.66 5.919.663"
        />
      </g>
      <g stroke="#000">
        <path
          fill="#9f7e00"
          d="M810.082 344.082c11.573-.019 24.315-1.772 29.023-2.989 3.138-.915 4.977-2.333 4.637-3.97-.158-.777-.838-1.452-1.753-1.84-6.903-2.213-19.347-3.784-31.907-3.804-12.536.02-25.043 1.59-31.97 3.804-.885.388-1.585 1.063-1.728 1.84-.355 1.637 1.485 3.055 4.641 3.97 4.695 1.217 17.494 2.97 29.057 2.989z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#e6e6e6"
          d="M838.142 298.17c0-1.136.963-2.046 2.137-2.046 1.197 0 2.16.91 2.16 2.045 0 1.13-.963 2.027-2.16 2.027-1.174 0-2.137-.896-2.137-2.027m-1.212-7.132c0-1.13.959-2.04 2.142-2.04 1.188 0 2.155.91 2.155 2.04 0 1.116-.967 2.031-2.155 2.031-1.183 0-2.141-.915-2.141-2.031zm-5.388-4.46c0-1.13.958-2.04 2.16-2.04 1.169 0 2.141.91 2.141 2.04 0 1.136-.972 2.046-2.141 2.046-1.202 0-2.16-.91-2.16-2.046zm-6.73-2.145c0-1.145.967-2.06 2.16-2.06 1.197 0 2.146.915 2.146 2.06 0 1.101-.949 2.03-2.146 2.03-1.193 0-2.16-.929-2.16-2.03zm-6.846.239c0-1.135.959-2.045 2.142-2.045 1.197 0 2.16.91 2.16 2.045 0 1.13-.963 2.026-2.16 2.026-1.183 0-2.142-.896-2.142-2.026z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          strokeLinecap="round"
          d="M859.406 312.017c.642-1.57 1.044-3.31 1.044-5.115 0-7.569-6.002-13.719-13.441-13.719a13.1 13.1 0 0 0-6.548 1.758"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          d="M835.465 302.39c.694-1.232 1.197-2.736 1.197-4.154 0-5.455-5.638-9.881-12.574-9.881-2.965 0-5.676.81-7.812 2.14"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#e6e6e6"
          d="M861.26 305.805c0-1.116.981-2.046 2.16-2.046 1.192 0 2.155.93 2.155 2.046 0 1.13-.963 2.026-2.155 2.026-1.179 0-2.16-.896-2.16-2.026zm-.81-7.501c0-1.136.972-2.027 2.16-2.027 1.183 0 2.146.891 2.146 2.027 0 1.116-.963 2.026-2.146 2.026-1.188 0-2.16-.91-2.16-2.026zm-4.829-5.744c0-1.116.963-2.026 2.142-2.026 1.197 0 2.155.91 2.155 2.026 0 1.13-.958 2.04-2.155 2.04-1.179 0-2.142-.91-2.142-2.04zm-6.457-3.06c0-1.112.963-2.027 2.156-2.027 1.183 0 2.146.915 2.146 2.026 0 1.136-.963 2.065-2.146 2.065-1.193 0-2.156-.93-2.156-2.065zm-6.864.272c0-1.13.963-2.045 2.156-2.045 1.192 0 2.16.915 2.16 2.045 0 1.117-.968 2.027-2.16 2.027-1.193 0-2.156-.91-2.156-2.027z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#9f7e00"
        d="m329.9 220.382-.573-.566s-.55.367-1.235.255c-.683-.112-.902-1.016-.902-1.016s-.77.7-1.395.648c-.629-.06-1.04-.648-1.04-.648s-.687.532-1.29.48c-.602-.06-1.177-.878-1.177-.878s-.602.848-1.206.907c-.603.054-1.094-.57-1.094-.57s-.276.623-1.043.762c-.766.142-1.424-.65-1.424-.65s-.432.766-.956.965c-.52.198-1.202-.286-1.202-.286s-.11.286-.193.455c-.083.169-.302.198-.302.198l.172.507c1.876-.593 4.422-.96 7.3-.964 2.88.003 5.496.371 7.371.968l.194-.567"
      />
      <g stroke="#000">
        <path
          fill="none"
          d="m847.234 321.986-2.812-2.549s-2.697 1.653-6.064 1.145c-3.353-.503-4.426-4.574-4.426-4.574s-3.78 3.156-6.85 2.921c-3.085-.273-5.101-2.921-5.101-2.921s-3.373 2.395-6.333 2.16c-2.96-.268-5.782-3.952-5.782-3.952s-2.955 3.818-5.92 4.086c-2.96.24-5.37-2.567-5.37-2.567s-1.355 2.806-5.12 3.43c-3.76.641-6.99-2.923-6.99-2.923s-2.121 3.444-4.693 4.34c-2.549.896-5.902-1.284-5.902-1.284s-.536 1.284-.944 2.046c-.412.761-1.485.895-1.485.895l.844 2.28c9.21-2.668 21.708-4.325 35.834-4.34 14.145.015 26.983 1.672 36.19 4.36l.948-2.553h-.025z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#e6e6e6"
          d="M777.442 298.17c0-1.136.958-2.046 2.156-2.046 1.173 0 2.141.91 2.141 2.045 0 1.13-.968 2.027-2.141 2.027-1.198 0-2.156-.896-2.156-2.027zm1.212-7.133c0-1.13.963-2.04 2.156-2.04 1.178 0 2.14.91 2.14 2.04 0 1.116-.962 2.031-2.14 2.031-1.193 0-2.156-.915-2.156-2.031zm5.37-4.46c0-1.13.963-2.04 2.155-2.04 1.198 0 2.16.91 2.16 2.04 0 1.136-.962 2.046-2.16 2.046-1.192 0-2.155-.91-2.155-2.046zm6.725-2.145c0-1.145.963-2.06 2.156-2.06 1.197 0 2.16.915 2.16 2.06 0 1.101-.963 2.03-2.16 2.03-1.193 0-2.156-.929-2.156-2.03zm6.864.239c0-1.135.963-2.045 2.142-2.045 1.197 0 2.16.91 2.16 2.045 0 1.13-.963 2.026-2.16 2.026-1.179 0-2.142-.896-2.142-2.026z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          strokeLinecap="round"
          d="M760.461 312.017c-.627-1.57-1.034-3.31-1.034-5.115 0-7.569 6.006-13.719 13.44-13.719 2.377 0 4.604.642 6.554 1.758"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          d="M784.575 302.222c-.695-1.217-1.36-2.568-1.36-3.986 0-5.455 5.642-9.881 12.578-9.881 2.941 0 5.672.81 7.813 2.14"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#e6e6e6"
          d="M754.306 305.805c0-1.116.958-2.046 2.16-2.046 1.17 0 2.137.93 2.137 2.046 0 1.13-.968 2.026-2.137 2.026-1.202 0-2.16-.896-2.16-2.026zm.8-7.501c0-1.136.982-2.027 2.16-2.027 1.198 0 2.16.891 2.16 2.027 0 1.116-.962 2.026-2.16 2.026-1.178 0-2.16-.91-2.16-2.026zm4.852-5.744c0-1.116.963-2.026 2.16-2.026 1.179 0 2.142.91 2.142 2.026 0 1.13-.963 2.04-2.141 2.04-1.198 0-2.16-.91-2.16-2.04zm6.457-3.06c0-1.112.963-2.027 2.137-2.027 1.202 0 2.16.915 2.16 2.026 0 1.136-.958 2.065-2.16 2.065-1.174 0-2.137-.93-2.137-2.065zm6.85.272c0-1.13.963-2.045 2.16-2.045 1.193 0 2.142.915 2.142 2.045 0 1.117-.949 2.027-2.141 2.027-1.198 0-2.16-.91-2.16-2.027z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="m810.154 309.67 1.336.24c-.21.555-.254 1.145-.254 1.772 0 2.769 2.38 5.015 5.303 5.015 2.357 0 4.354-1.451 5.034-3.463.082.053.513-1.825.724-1.791.2 0 .167 1.944.215 1.91.355 2.516 2.654 4.24 5.264 4.24 2.922 0 5.293-2.246 5.293-5.015 0-.206-.015-.407-.05-.608l1.677-1.658.886 2.113c-.354.641-.498 1.384-.498 2.18 0 2.653 2.27 4.799 5.054 4.799 1.767 0 3.32-.863 4.21-2.146l1.068-1.351-.02 1.672c0 1.652.719 3.142 2.333 3.41 0 0 1.873.134 4.34-1.825 2.481-1.94 3.837-3.564 3.837-3.564l.143 1.993s-2.433 3.985-4.622 5.255c-1.212.709-3.056 1.451-4.512 1.197-1.557-.234-2.64-1.485-3.215-2.903a7.404 7.404 0 0 1-3.798 1.03c-2.994 0-5.686-1.657-6.74-4.105-1.38 1.485-3.3 2.38-5.551 2.38-2.386 0-4.58-1.062-5.96-2.734-1.35 1.25-3.185 2.012-5.206 2.012-2.635 0-5.01-1.322-6.347-3.262-1.341 1.94-3.679 3.262-6.337 3.262a7.643 7.643 0 0 1-5.202-2.012c-1.375 1.672-3.55 2.735-5.96 2.735-2.246 0-4.157-.896-5.527-2.38-1.059 2.433-3.765 4.104-6.745 4.104a7.378 7.378 0 0 1-3.784-1.03c-.57 1.418-1.672 2.669-3.21 2.903-1.46.254-3.3-.488-4.511-1.197-2.213-1.27-4.834-5.255-4.834-5.255l.34-1.993s1.351 1.624 3.818 3.564c2.477 1.96 4.35 1.825 4.35 1.825 1.623-.268 2.313-1.758 2.313-3.41v-1.672l1.059 1.35a5.157 5.157 0 0 0 4.206 2.147c2.807 0 5.067-2.146 5.067-4.8 0-.795-.143-1.538-.498-2.18l.891-2.112 1.658 1.658c-.035.2-.035.402-.035.608 0 2.769 2.356 5.015 5.254 5.015 2.63 0 4.93-1.724 5.27-4.24.072.034.05-1.91.23-1.91.235-.034.66 1.844.732 1.791.695 2.012 2.693 3.463 5.044 3.463 2.932 0 5.303-2.246 5.303-5.015 0-.627-.035-1.217-.249-1.772l1.375-.24h.035z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <g strokeWidth={0.987}>
        <path
          fill="#c8b100"
          d="M322.332 220.544c-2.922.003-5.546.382-7.43.99-.128.045-.282-.06-.324-.184-.04-.13.051-.293.173-.337 1.898-.63 4.587-1.029 7.58-1.032 2.991.003 5.694.401 7.588 1.032.126.044.218.206.178.337-.04.123-.2.229-.323.184-1.886-.608-4.52-.987-7.442-.99"
        />
        <path
          fill="#9f7e00"
          stroke="#000"
          d="M800.775 322.714c-13.966.014-26.508 1.72-35.52 4.46-.606.2-1.344-.274-1.544-.83-.196-.589.243-1.317.826-1.518 9.072-2.84 21.928-4.632 36.238-4.646 14.298.014 27.218 1.806 36.272 4.646.602.201 1.04.93.85 1.518-.193.556-.957 1.03-1.545.83-9.017-2.74-21.61-4.446-35.577-4.46z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#fff"
          d="M319.505 221.672c0-.24.19-.435.425-.435a.43.43 0 0 1 .422.435c0 .244-.19.435-.422.435a.427.427 0 0 1-.425-.435"
        />
        <path
          fill="#e6e6e6"
          stroke="#000"
          d="M787.262 327.796c0-1.078.906-1.96 2.034-1.96 1.11 0 2.015.882 2.015 1.96 0 1.097-.905 1.959-2.016 1.959-1.128 0-2.033-.862-2.033-1.96z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#b50027"
          d="M322.368 221.86h-.94a.328.328 0 0 1-.321-.33.32.32 0 0 1 .316-.322h1.901c.175 0 .311.145.311.322 0 .18-.14.33-.315.33z"
        />
        <path
          fill="none"
          stroke="#000"
          d="M800.949 328.644h-4.497c-.836 0-1.531-.676-1.531-1.49 0-.795.677-1.451 1.511-1.451h9.088c.834 0 1.488.656 1.488 1.451 0 .814-.672 1.49-1.508 1.49z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#006f46"
          d="m317.66 222.213-.672.108a.322.322 0 0 1-.365-.273.32.32 0 0 1 .262-.368l.675-.109.69-.116a.322.322 0 0 1 .361.27.328.328 0 0 1-.265.372z"
        />
        <path
          fill="none"
          stroke="#000"
          d="m778.442 330.23-3.214.488c-.826.12-1.6-.422-1.74-1.231a1.457 1.457 0 0 1 1.25-1.658l3.227-.488 3.299-.522c.825-.1 1.586.421 1.725 1.216.122.79-.452 1.552-1.269 1.672z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path fill="#b50027" d="m314.944 222.726.299-.524.64.13-.372.59z" />
        <path
          fill="none"
          stroke="#000"
          d="m765.46 332.543 1.428-2.362 3.06.59-1.778 2.653z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#fff"
          d="M324.316 221.672c0-.24.193-.435.425-.435.233 0 .425.196.425.435a.43.43 0 0 1-.425.435.43.43 0 0 1-.425-.435"
        />
        <path
          fill="#e6e6e6"
          stroke="#000"
          d="M810.263 327.796c0-1.078.92-1.96 2.03-1.96 1.114 0 2.033.882 2.033 1.96 0 1.097-.919 1.959-2.034 1.959-1.11 0-2.029-.862-2.029-1.96z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#006f46"
          d="m327.008 222.213.677.108c.17.027.33-.094.359-.273.024-.177-.087-.342-.258-.368l-.676-.109-.69-.116a.318.318 0 0 0-.36.27.325.325 0 0 0 .266.372z"
        />
        <path
          fill="none"
          stroke="#000"
          d="m823.132 330.23 3.233.488a1.51 1.51 0 0 0 1.716-1.231 1.45 1.45 0 0 0-1.23-1.658l-3.233-.488-3.298-.522c-.835-.1-1.6.421-1.721 1.216-.14.79.452 1.552 1.269 1.672z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#b50027"
          d="m329.668 222.756-.24-.558-.655.06.314.626.581-.128"
        />
        <path
          fill="none"
          stroke="#000"
          d="m835.74 332.522-1.04-2.36-3.134.268 1.502 2.822c.95-.219 1.866-.54 2.672-.73z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#b50027"
          d="M322.328 224.692c-2.358-.004-4.49-.229-6.115-.686 1.624-.454 3.757-.735 6.115-.743 2.358.004 4.502.285 6.122.743-1.62.457-3.764.682-6.122.686"
        />
        <path
          fill="none"
          stroke="#000"
          strokeLinejoin="round"
          d="M800.757 341.395c-11.27-.015-21.466-1.03-29.233-3.09 7.767-2.045 17.963-3.31 29.233-3.343 11.274.014 21.522 1.284 29.265 3.343-7.743 2.06-17.99 3.075-29.265 3.09z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M329.763 219.119c.062-.2.007-.395-.129-.444-.13-.04-.286.087-.347.278-.065.203-.008.402.123.447.13.04.29-.083.353-.281"
        />
        <path
          fill="#e6e6e6"
          stroke="#000"
          d="M836.3 316.295c.294-.896.034-1.777-.615-1.998-.625-.182-1.366.393-1.66 1.25-.313.916-.04 1.811.587 2.013.625.186 1.39-.37 1.688-1.265z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M325.068 218.128c.025-.206-.07-.39-.207-.41-.135-.017-.27.14-.291.347-.025.206.065.389.204.408.138.015.268-.142.294-.345"
        />
        <path
          fill="#e6e6e6"
          stroke="#000"
          d="M813.854 311.835c.122-.929-.33-1.758-.988-1.844-.644-.081-1.287.628-1.39 1.557-.121.93.312 1.753.975 1.84.657.066 1.283-.642 1.403-1.553z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M319.618 218.128c-.025-.206.065-.39.203-.41.139-.017.268.14.295.347.02.206-.07.389-.204.408-.138.015-.27-.142-.294-.345"
        />
        <path
          fill="#e6e6e6"
          stroke="#000"
          d="M787.803 311.835c-.121-.929.308-1.758.97-1.844.663-.081 1.283.628 1.41 1.557.097.93-.331 1.753-.975 1.84-.658.066-1.288-.642-1.404-1.553z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M314.923 219.119c-.066-.2-.007-.395.124-.444.13-.04.29.087.352.278.061.203.007.402-.123.447-.135.04-.292-.083-.353-.281"
        />
      </g>
      <g stroke="#000">
        <path
          fill="#e6e6e6"
          d="M773.71 316.295c-.32-.896-.034-1.777.61-1.998.636-.182 1.422.393 1.728 1.25.302.916.035 1.811-.603 2.013-.661.186-1.433-.37-1.734-1.265z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="m810.063 298.524-4.081 2.462 3.027 6.572 1.054.694 1.04-.694 3.046-6.572c-1.362-.82-2.71-1.664-4.086-2.462z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m801.105 308.454 1.864 2.706 6.366-1.964.675-.89-.675-.916-6.366-1.858a44.75 44.75 0 0 0-1.864 2.922zm17.949 0-1.873 2.706-6.366-1.964-.676-.89.676-.916 6.366-1.858c.655.954 1.263 1.938 1.873 2.922zm-35.557-7.008-3.2 3.022 4.1 5.408 1.088.436.805-.828 1.441-6.534a202.557 202.557 0 0 0-4.234-1.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m776.781 312.29 2.405 2.261L785 311.41l.446-1.01-.834-.762-6.653-.575c-.445 1.057-.805 2.145-1.179 3.228zm17.551-3.53-1.23 2.99-6.66-.61-.866-.76.46-1.03 5.834-3.076c.847.803 1.651 1.647 2.462 2.486zm-23.955 4.374-.551 3.16-6.663.69-1.01-.574.253-1.078 5.006-4.158c.965.69 1.965 1.323 2.965 1.96z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path
        fill="#c8b100"
        d="M316.857 217.813c0-.274.213-.495.475-.495.265 0 .476.221.476.495 0 .27-.21.491-.476.491a.485.485 0 0 1-.475-.491"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M783.205 310.413c0-1.231 1.049-2.228 2.333-2.228 1.302 0 2.337.997 2.337 2.228 0 1.216-1.035 2.213-2.337 2.213-1.284 0-2.333-.997-2.333-2.213z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="m836.715 301.446 3.21 3.022-4.106 5.408-1.087.436-.8-.828-1.447-6.534a82.76 82.76 0 0 0 4.23-1.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m843.44 312.29-2.41 2.261-5.814-3.142-.465-1.01.858-.762 6.653-.575c.463 1.072.794 2.129 1.178 3.228zm-17.555-3.53 1.23 2.99 6.659-.61.852-.76-.445-1.03-5.83-3.076c-.81.841-1.636 1.665-2.466 2.486z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <g strokeWidth={0.987}>
        <path
          fill="#c8b100"
          d="m330.249 218.417.11.701 1.354.154.204-.128-.051-.24-1.017-.922-.6.435"
        />
        <path
          fill="#9f7e00"
          stroke="#000"
          d="m838.624 313.134.522 3.16 6.474.69.975-.574-.242-1.078-4.86-4.158c-.964.644-1.926 1.288-2.87 1.96z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M321.86 217.348a.48.48 0 0 1 .476-.495c.257 0 .476.217.476.495 0 .27-.216.491-.476.491a.482.482 0 0 1-.477-.491"
        />
        <path
          fill="#b50027"
          stroke="#000"
          d="M798.518 308.32c0-1.25 1.003-2.228 2.276-2.228 1.232 0 2.277.977 2.277 2.228 0 1.216-1.032 2.213-2.277 2.213-1.274 0-2.276-.997-2.276-2.213z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M326.874 217.813c0-.274.214-.495.476-.495.265 0 .48.221.48.495 0 .27-.215.491-.48.491a.485.485 0 0 1-.476-.491"
        />
        <path
          fill="#b50027"
          stroke="#000"
          d="M822.489 310.413c0-1.231 1.021-2.228 2.276-2.228 1.265 0 2.295.997 2.295 2.228 0 1.216-1.03 2.213-2.295 2.213-1.255 0-2.276-.997-2.276-2.213z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M322.968 211.47v.612h-1.382v-.611h.452v-1.381h-.6v-.615h.6v-.604h.592v.604h.589v.615h-.589v1.38h.334"
        />
      </g>
      <g stroke="#000">
        <path
          fill="none"
          d="M813.205 281.85v2.754h-6.783v-2.754h2.218v-6.218h-2.946v-2.768h2.946v-2.721h2.908v2.72h2.888v2.77h-2.888v6.217h1.658z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#0044ad"
          d="M811.875 278c2.416.654 4.171 2.785 4.171 5.296 0 3.046-2.607 5.513-5.85 5.513-3.217 0-5.825-2.467-5.825-5.513 0-2.556 1.825-4.686 4.312-5.341"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M761.15 316.53a23.413 23.413 0 0 0-2.902-3.176c-.929-.829-3.21-1.538-3.21-1.538 0-.421 1.337-1.37 2.784-1.37.838 0 1.638.355 2.112.949l.168-.915s1.178.22 1.696 1.523c.536 1.35.196 3.396.196 3.396-.186.432-.574.746-.844 1.132z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M761.458 315.667c.555-.574 1.695-.455 2.534.274.857.723 1.106 1.786.546 2.38-.546.59-1.672.455-2.525-.273-.862-.723-1.106-1.806-.555-2.38z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <g strokeWidth={0.987}>
        <path
          fill="#c8b100"
          d="M332.08 219.238c.014.011.366-.51.637-.772.185-.184.654-.342.654-.342 0-.093-.273-.304-.568-.304a.54.54 0 0 0-.432.21l-.036-.202s-.24.048-.345.338c-.108.3-.041.754-.041.754s.044.21.13.318"
        />
        <path
          fill="#9f7e00"
          stroke="#000"
          d="M847.374 316.831c.07.053 1.754-2.294 3.046-3.477.886-.829 3.126-1.538 3.126-1.538 0-.421-1.302-1.37-2.711-1.37-.816 0-1.6.355-2.066.949l-.173-.915s-1.152.22-1.65 1.523c-.518 1.35-.196 3.396-.196 3.396-.02.592.241.772.624 1.432z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#c8b100"
          d="M332.092 218.98c-.114-.128-.345-.102-.52.06-.174.16-.221.397-.113.528.113.131.345.102.52-.06.174-.16.225-.401.113-.529"
        />
      </g>
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M857.997 315.667c-.56-.574-1.695-.455-2.553.274-.857.723-1.087 1.786-.555 2.38.555.59 1.695.455 2.548-.273.857-.723 1.111-1.806.56-2.38z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M816.237 281.85v2.754h-12.056v-2.754h4.46v-6.218h-2.947v-2.768h2.946v-2.721h2.908v2.72h2.903v2.77h-2.903v6.217h3.65z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="none">
          <path
            strokeWidth={0.1}
            d="M809.975 341.444v-6.03m-1.638 6.03v-6.03"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.25}
            d="M806.79 341.444v-6.03m-1.532 6.03v-6.03m-1.366 6.03v-6.03m-2.605 5.706-.036-5.49m1.271 5.562v-5.742"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.5}
            d="M798.882 340.873v-5.057m1.219 5.201-.036-5.382m-4.408 4.948v-4.442m1.058 4.515v-4.66m1.09 4.805v-4.841"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.75}
            d="M794.525 340.547v-4.298m-1.054 4.387v-4.703m-1.131 4.567v-4.387m-2.315 4.007-.036-3.712m1.222 3.939v-4.1"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M788.838 340.033v-3.35m-1.086 3.388v-3.219m-1.186 2.598v-2.418m-1.22 2.44v-2.207m-1.29 1.919v-1.64"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.1}
            d="M816.49 341.12v-5.525m-2.774 5.705.036-5.85m-2.058 5.922v-5.958"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path fill="#dead00" d="M311.466 231.292h21.597v-6.17h-21.597z" />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M756.742 371.123h106.02v-27.792h-106.02z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M330.797 235.399a.879.879 0 0 0-.4-.067h-16.173c-.16 0-.313.03-.447.086.556-.202.955-.75.955-1.395s-.435-1.204-.995-1.414c.134.045.315.086.475.086h16.185c.162 0 .316-.007.454-.056l-.091.015c-.578.194-.909.754-.909 1.369 0 .592.367 1.185.946 1.376"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.857}
        d="M851.639 389.618c-.666-.269-1.17-.302-1.964-.302h-79.396c-.786 0-1.533.134-2.194.388 2.73-.91 4.69-3.377 4.69-6.285 0-2.902-2.137-5.422-4.887-6.366.661.202 1.548.388 2.333.388h79.454c.795 0 1.552-.033 2.227-.254l-.446.067c-2.835.877-4.46 3.397-4.46 6.165 0 2.668 1.802 5.341 4.642 6.199z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M314.224 235.332h16.173c.544 0 .988.371.988.825 0 .458-.444.829-.988.829h-16.173c-.549 0-.993-.371-.993-.829 0-.454.444-.825.993-.825"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M770.279 389.316h79.396c2.672 0 4.852 1.672 4.852 3.717 0 2.06-2.18 3.731-4.852 3.731h-79.396c-2.692 0-4.872-1.671-4.872-3.731 0-2.045 2.18-3.717 4.872-3.717z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M314.212 231.292h16.185c.544 0 .988.315.988.698 0 .39-.444.705-.988.705h-16.185c-.548 0-.992-.315-.992-.705 0-.383.444-.698.992-.698"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M770.221 371.123h79.454c2.672 0 4.852 1.418 4.852 3.143 0 1.753-2.18 3.175-4.852 3.175H770.22c-2.687 0-4.867-1.422-4.867-3.175 0-1.725 2.18-3.143 4.867-3.143z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M330.793 324.683c-.05.214-.12.424-.12.653 0 1.545 1.224 2.775 2.717 2.775h-22.223c1.494 0 2.715-1.23 2.715-2.775 0-.225-.04-.44-.084-.653.12.049.273.056.422.056h16.173c.13 0 .283-.014.396-.056"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.857}
        d="M851.62 791.733c-.25.963-.59 1.911-.59 2.941 0 6.96 6.007 12.497 13.34 12.497H755.272c7.334 0 13.331-5.537 13.331-12.497 0-1.015-.196-1.978-.412-2.941.59.22 1.341.254 2.07.254h79.395c.642 0 1.39-.067 1.945-.254h.02z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M314.224 323.082h16.173c.544 0 .988.375.988.829 0 .457-.444.828-.988.828h-16.173c-.549 0-.993-.37-.993-.828 0-.454.444-.83.993-.83"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M770.279 784.52h79.396c2.672 0 4.852 1.69 4.852 3.735 0 2.06-2.18 3.732-4.852 3.732h-79.396c-2.692 0-4.872-1.672-4.872-3.732 0-2.045 2.18-3.736 4.872-3.736z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path fill="#dead00" d="M311.193 334.274h22.17v-6.163h-22.17z" />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M755.4 834.93h108.832v-27.76H755.4z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M335.094 301.27c2.196 1.381 3.686 2.795 3.446 3.5-.121.649-.818 1.133-1.813 1.853-1.566 1.189-2.523 3.312-1.777 4.291a6.3 6.3 0 0 1-2.112-4.737c0-1.98.862-3.766 2.256-4.906"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M872.734 686.29c10.778 6.217 18.092 12.583 16.914 15.759-.594 2.922-4.014 5.101-8.9 8.344-7.688 5.355-12.382 14.916-8.723 19.328-6.351-5.135-10.366-12.804-10.366-21.335 0-8.919 4.23-16.962 11.075-22.096z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path fill="#b2b2b2" d="M314.434 322.084h15.752v-84.119h-15.752z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M827.405 401.037v378.04m8.694-378.04v378.04m-64.786.949h77.327v-378.85h-77.327z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M298.345 269.43c3.44-1.549 9.283-2.696 15.988-2.937 2.31.02 4.885.256 7.546.74 9.419 1.713 16.595 5.813 16.024 9.151-.011.072-.028.217-.046.281 0 0 3.534-8.675 3.585-9.005.633-3.705-7.326-8.26-17.782-10.161a49.625 49.625 0 0 0-9.262-.799c-6.692 0-12.507.934-16.01 2.351l-.043 10.379"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.857}
        d="M692.33 542.885c16.884-6.974 45.572-12.143 78.485-13.225 11.338.086 23.984 1.15 37.047 3.329 46.234 7.717 81.465 26.182 78.663 41.218-.058.321-.14.977-.23 1.265 0 0 17.35-39.073 17.603-40.558 3.104-16.688-35.964-37.2-87.294-45.764-16.11-2.687-31.84-3.731-45.468-3.597-32.855 0-61.4 4.206-78.591 10.59l-.216 46.742"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M330.214 279.989c4.369-.342 7.352-1.614 7.69-3.605.273-1.586-1.207-3.341-3.841-4.935-1.18.138-2.508.314-3.877.314l.028 8.226"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M848.779 590.44c21.445-1.537 36.088-7.266 37.746-16.233 1.341-7.147-5.92-15.05-18.854-22.23-5.796.622-12.31 1.417-19.031 1.417l.139 37.047"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M314.409 273.56c-2.732.45-4.78 1.189-5.804 2.097l-.09.183c-.49 1.088 1.911 3.402 5.915 5.987z"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M771.189 561.485c-13.413 2.026-23.462 5.355-28.492 9.446l-.44.824c-2.41 4.9 9.379 15.323 29.037 26.963z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b50027"
        d="M339.996 296.215c.414-1.359-3.845-4.077-9.864-6.485-2.751-1.073-5.023-2.19-7.838-3.545-8.361-4.029-14.539-8.653-13.776-10.34l.081-.173c-.44.393-1.13 8.7-1.13 8.7-.763 1.546 4.89 6.104 12.582 10.125 2.465 1.283 7.67 3.379 10.127 4.317 4.393 1.661 8.758 4.793 8.362 5.956l1.456-8.551"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeLinejoin="round"
          strokeWidth={1.857}
          d="M896.8 663.518c2.03-6.117-18.878-18.36-48.428-29.205-13.504-4.833-24.655-9.868-38.474-15.966-41.047-18.144-71.373-38.971-67.627-46.573l.397-.776c-2.16 1.772-5.547 39.187-5.547 39.187-3.745 6.96 24.008 27.486 61.764 45.597 12.1 5.777 37.655 15.218 49.716 19.443 21.566 7.482 42.992 21.588 41.047 26.824l7.152-38.512v-.02z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          strokeWidth={0.5}
          d="M740.523 526.283c2.926-11.099 6.706-21.829 10.418-32.688-.82.22-1.71.388-2.534.522-.833.12-1.73.201-2.582.235-1.767 7.808-4.158 15.644-6.725 23.48-4.57-6.854-9.547-13.512-13.503-20.438-1.586.32-3.234.709-4.853.948-1.59.235-3.286.355-4.924.508 6.902 9.254 13.575 18.513 19.98 28.122.766-.2 1.508-.455 2.356-.575.767-.1 1.567-.081 2.367-.115m29.401-32.466c-1.413.067-2.821.167-4.234.148-1.404-.015-2.812-.182-4.206-.287l-.57 30.508 21.335.359c-.11-.628-.268-1.303-.249-1.945 0-.628.197-1.284.297-1.911-3.818.254-7.985.493-12.876.407l.503-27.28m33.493 5.015c3.41.288 6.691.877 9.977 1.471-.062-.641-.163-1.283-.11-1.944.05-.623.288-1.25.465-1.859l-28.88-2.395c.072.642.177 1.265.11 1.892-.057.676-.287 1.284-.455 1.907 2.946-.067 6.5-.1 10.476.234l-2.515 27.452c1.409.035 2.817.02 4.211.134 1.403.105 2.802.354 4.191.56l2.515-27.451m11.827 30.067c1.394.22 2.797.388 4.177.695 1.37.287 2.711.728 4.048 1.116l3.424-14.02.374.08c.8 1.926 1.84 4.273 2.371 5.629l4.282 10.59c1.677.27 3.349.49 4.997.844 1.69.373 3.31.862 4.938 1.317l-1.485-3.176c-2.304-4.78-4.723-9.541-6.72-14.389 5.317.235 9.436-1.69 10.47-5.964.734-2.974-.45-5.307-3.252-7.3-2.064-1.47-6.073-2.246-8.66-2.82l-11.65-2.55-7.314 29.948m14.945-25.794c3.358.742 7.55 1.283 7.55 5.101-.02.963-.11 1.638-.27 2.247-1.087 4.478-4.478 6.03-10.13 4.344l2.85-11.692m40.06 34.933c-.259 3.31-.848 6.525-1.49 10.002 1.461.695 2.908 1.317 4.316 2.093 1.408.781 2.706 1.639 4.067 2.486l2.855-34.392a20.15 20.15 0 0 1-1.926-.896 16.896 16.896 0 0 1-1.792-1.135l-30.32 19.26c.799.389 1.628.743 2.408 1.165.786.44 1.447.91 2.233 1.35 2.543-2.146 5.226-3.884 8.291-6.164l11.348 6.217.01.015zm-8.594-7.855 10.098-6.534-1.179 11.4z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#005bbf"
        d="M307.185 335.133c1.497 0 2.826-.342 3.808-.912.975-.54 2.293-.87 3.746-.87 1.458 0 2.813.334 3.787.878.973.56 2.325.904 3.8.904 1.49 0 2.827-.38 3.809-.949.966-.518 2.256-.833 3.676-.833 1.465 0 2.762.304 3.74.855.976.567 2.34.927 3.828.927v2.55c-1.489 0-2.852-.371-3.829-.934-.977-.548-2.274-.858-3.739-.858-1.42 0-2.71.318-3.676.84-.978.566-2.319.952-3.809.952-1.471 0-2.824-.352-3.8-.907-.974-.551-2.326-.885-3.787-.885-1.453 0-2.771.334-3.746.877-.982.57-2.292.915-3.786.915l-.022-2.55"
      />
      <path
        fill="#0045af"
        stroke="#000"
        strokeWidth={1.857}
        d="M735.728 838.795c7.348 0 13.872-1.537 18.69-4.105 4.786-2.433 11.257-3.918 18.39-3.918 7.156 0 13.81 1.504 18.59 3.952 4.78 2.52 11.415 4.071 18.658 4.071 7.314 0 13.877-1.705 18.695-4.272 4.743-2.333 11.075-3.751 18.05-3.751 7.19 0 13.556 1.37 18.355 3.851 4.795 2.553 11.487 4.172 18.797 4.172v11.487c-7.31 0-14.002-1.672-18.797-4.206-4.8-2.467-11.166-3.865-18.356-3.865-6.974 0-13.306 1.432-18.049 3.784-4.8 2.548-11.38 4.287-18.695 4.287-7.224 0-13.863-1.586-18.658-4.086-4.78-2.481-11.415-3.985-18.59-3.985-7.133 0-13.604 1.504-18.39 3.951-4.818 2.568-11.251 4.12-18.585 4.12z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b2b2b2"
        d="M307.185 337.683c1.497 0 2.826-.345 3.808-.915.975-.543 2.293-.877 3.746-.877 1.458 0 2.813.334 3.787.885.973.555 2.325.907 3.8.907 1.49 0 2.827-.386 3.809-.952.966-.522 2.256-.84 3.676-.84 1.465 0 2.762.31 3.74.858.976.563 2.34.934 3.828.934v2.543c-1.489 0-2.852-.364-3.829-.926-.977-.555-2.274-.863-3.739-.863-1.42 0-2.71.32-3.676.84-.978.567-2.319.949-3.809.949-1.471 0-2.824-.352-3.8-.907-.974-.548-2.326-.882-3.787-.882-1.453 0-2.771.334-3.746.878-.982.566-2.292.911-3.786.911l-.022-2.543"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M735.728 850.282c7.348 0 13.872-1.552 18.69-4.12 4.786-2.447 11.257-3.951 18.39-3.951 7.156 0 13.81 1.504 18.59 3.985 4.78 2.5 11.415 4.086 18.658 4.086 7.314 0 13.877-1.739 18.695-4.287 4.743-2.352 11.075-3.784 18.05-3.784 7.19 0 13.556 1.398 18.355 3.865 4.795 2.534 11.487 4.206 18.797 4.206v11.453c-7.31 0-14.002-1.638-18.797-4.172-4.8-2.5-11.166-3.885-18.356-3.885-6.974 0-13.306 1.437-18.049 3.784-4.8 2.553-11.38 4.273-18.695 4.273-7.224 0-13.863-1.586-18.658-4.086-4.78-2.467-11.415-3.971-18.59-3.971-7.133 0-13.604 1.504-18.39 3.952-4.818 2.553-11.251 4.105-18.585 4.105l-.105-11.453"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#005bbf"
        d="M307.185 340.226c1.497 0 2.826-.345 3.808-.911.975-.544 2.293-.878 3.746-.878 1.458 0 2.813.334 3.787.882.973.555 2.325.907 3.8.907 1.49 0 2.827-.382 3.809-.949.966-.52 2.256-.84 3.676-.84 1.465 0 2.762.307 3.74.863.976.562 2.34.926 3.828.926v2.543c-1.489 0-2.852-.364-3.829-.93-.977-.547-2.274-.854-3.739-.854-1.42 0-2.71.318-3.676.835-.978.57-2.319.949-3.809.949-1.471 0-2.824-.348-3.8-.903-.974-.548-2.326-.881-3.787-.881-1.453 0-2.771.329-3.746.874-.982.573-2.292.91-3.786.91l-.022-2.543"
      />
      <path
        fill="#0045af"
        stroke="#000"
        strokeWidth={1.857}
        d="M735.728 861.735c7.348 0 13.872-1.552 18.69-4.105 4.786-2.448 11.257-3.952 18.39-3.952 7.156 0 13.81 1.504 18.59 3.97 4.78 2.501 11.415 4.087 18.658 4.087 7.314 0 13.877-1.72 18.695-4.273 4.743-2.347 11.075-3.784 18.05-3.784 7.19 0 13.556 1.384 18.355 3.885 4.795 2.534 11.487 4.172 18.797 4.172v11.453c-7.31 0-14.002-1.638-18.797-4.187-4.8-2.467-11.166-3.85-18.356-3.85-6.974 0-13.306 1.436-18.049 3.764-4.8 2.568-11.38 4.273-18.695 4.273-7.224 0-13.863-1.567-18.658-4.067-4.78-2.467-11.415-3.97-18.59-3.97-7.133 0-13.604 1.484-18.39 3.937-4.818 2.581-11.251 4.1-18.585 4.1l-.105-11.453"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b2b2b2"
        d="M307.207 345.316c1.494 0 2.804-.344 3.786-.915.975-.54 2.293-.87 3.746-.87 1.458 0 2.813.33 3.787.878.973.555 2.325.907 3.8.907 1.49 0 2.827-.383 3.809-.953.966-.517 2.256-.832 3.676-.832 1.465 0 2.762.308 3.74.854.976.568 2.34.931 3.828.931v-2.531c-1.489 0-2.852-.38-3.829-.946-.977-.547-2.274-.854-3.739-.854-1.42 0-2.71.318-3.676.835-.978.57-2.319.949-3.809.949-1.471 0-2.824-.348-3.8-.903-.974-.548-2.326-.881-3.787-.881-1.453 0-2.771.329-3.746.874-.982.573-2.31.91-3.808.91l.022 2.547"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M735.833 884.66c7.334 0 13.767-1.552 18.586-4.12 4.785-2.433 11.256-3.922 18.389-3.922 7.156 0 13.81 1.49 18.59 3.956 4.78 2.5 11.415 4.086 18.658 4.086 7.314 0 13.877-1.724 18.695-4.292 4.743-2.328 11.075-3.75 18.05-3.75 7.19 0 13.556 1.389 18.355 3.85 4.795 2.554 11.487 4.192 18.797 4.192v-11.4c-7.31 0-14.002-1.71-18.797-4.259-4.8-2.467-11.166-3.85-18.356-3.85-6.974 0-13.306 1.436-18.049 3.764-4.8 2.568-11.38 4.273-18.695 4.273-7.224 0-13.863-1.567-18.658-4.067-4.78-2.467-11.415-3.97-18.59-3.97-7.133 0-13.604 1.484-18.39 3.937-4.818 2.581-11.342 4.1-18.69 4.1l.105 11.472"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#005bbf"
        d="M307.207 347.863c1.494 0 2.804-.345 3.786-.911.975-.548 2.293-.882 3.746-.882 1.458 0 2.813.338 3.787.885.973.555 2.325.908 3.8.908 1.49 0 2.827-.387 3.809-.953.966-.52 2.256-.84 3.676-.84 1.465 0 2.762.312 3.74.863.976.562 2.34.93 3.828.93v-2.524c-1.489 0-2.852-.387-3.829-.953-.977-.547-2.274-.851-3.739-.851-1.42 0-2.71.315-3.676.832-.978.566-2.319.95-3.809.95-1.471 0-2.824-.353-3.8-.908-.974-.548-2.326-.874-3.787-.874-1.453 0-2.771.326-3.746.87-.982.567-2.307.911-3.8.911l.014 2.547"
      />
      <path
        fill="#0045af"
        stroke="#000"
        strokeWidth={1.857}
        d="M735.833 896.132c7.334 0 13.767-1.557 18.586-4.105 4.785-2.467 11.256-3.97 18.389-3.97 7.156 0 13.81 1.518 18.59 3.984 4.78 2.5 11.415 4.091 18.658 4.091 7.314 0 13.877-1.743 18.695-4.292 4.743-2.347 11.075-3.784 18.05-3.784 7.19 0 13.556 1.404 18.355 3.885 4.795 2.534 11.487 4.191 18.797 4.191v-11.371c-7.31 0-14.002-1.74-18.797-4.292-4.8-2.462-11.166-3.832-18.356-3.832-6.974 0-13.306 1.418-18.049 3.75-4.8 2.549-11.38 4.273-18.695 4.273-7.224 0-13.863-1.586-18.658-4.086-4.78-2.467-11.415-3.937-18.59-3.937-7.133 0-13.604 1.47-18.39 3.918-4.818 2.553-11.323 4.105-18.657 4.105z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M170.418 220.551s-.495 0-.767-.169c-.272-.172-1.094-1.02-1.094-1.02l-.657-.51-.6-.904s-.712-1.237-.385-2.202c.327-.96.875-1.302 1.37-1.583.494-.282 1.53-.622 1.53-.622s.825-.394 1.097-.454c.272-.056 1.26-.338 1.26-.338s.274-.168.546-.28c.276-.114.658-.114.88-.173.217-.056.766-.248 1.093-.267.508-.022 1.315.098 1.591.098.273 0 1.204.06 1.585.06s1.75-.117 2.136-.117c.381 0 .658-.052 1.098 0 .436.057 1.202.338 1.423.455.219.112 1.534.622 2.025.79.494.166 1.7.394 2.25.676.544.285.878.762 1.15 1.159.277.394.328.825.437 1.11.105.282.11.889.004 1.17-.11.282-.498.863-.498.863l-.604 1.072-.766.676s-.55.57-.984.51c-.44-.049-4.877-.904-7.726-.904s-7.398.904-7.398.904"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          strokeLinejoin="round"
          d="M64.325 322.747s-2.428 0-3.765-.761c-1.336-.776-5.37-4.594-5.37-4.594l-3.228-2.3-2.941-4.07s-3.497-5.572-1.892-9.916c1.604-4.326 4.296-5.863 6.725-7.128 2.424-1.27 7.51-2.802 7.51-2.802s4.049-1.777 5.385-2.045c1.336-.254 6.189-1.524 6.189-1.524s1.341-.757 2.677-1.264c1.356-.508 3.229-.508 4.316-.776 1.069-.254 3.765-1.116 5.37-1.203 2.496-.1 6.457.441 7.813.441 1.336 0 5.906.268 7.779.268s8.593-.522 10.485-.522c1.873 0 3.229-.234 5.39 0 2.14.254 5.9 1.519 6.988 2.046 1.073.507 7.53 2.802 9.94 3.563 2.423.743 8.344 1.773 11.04 3.042 2.673 1.284 4.316 3.43 5.653 5.217 1.356 1.777 1.605 3.717 2.141 5 .517 1.27.537 4.005.02 5.274-.542 1.265-2.444 3.885-2.444 3.885l-2.965 4.828-3.76 3.042s-2.697 2.567-4.833 2.3c-2.16-.221-23.941-4.072-37.924-4.072-13.987 0-36.318 4.071-36.318 4.071z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="M94.24 291.545c0-6.572 2.94-11.875 6.562-11.875 3.621 0 6.562 5.303 6.562 11.875 0 6.538-2.94 11.86-6.562 11.86s-6.563-5.322-6.563-11.86z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M97.913 291.545c0-6.045 1.356-10.946 3.013-10.946 1.677 0 3.013 4.9 3.013 10.946 0 5.997-1.336 10.897-3.013 10.897-1.657 0-3.013-4.9-3.013-10.897z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M100.907 321.986H78.04l-.531-5.61-1.073-5.843-1.14-7.296c-6.3-8.315-12.096-13.771-14.04-12.602.464-1.538 1.015-2.688 2.232-3.397 5.6-3.329 17.158 4.661 25.847 17.786.781 1.202 1.533 2.4 2.194 3.602h18.888a82.468 82.468 0 0 1 2.213-3.602c8.67-13.125 20.243-21.115 25.828-17.786 1.212.71 1.767 1.859 2.246 3.397-1.959-1.15-7.74 4.287-14.073 12.602l-1.126 7.296-1.068 5.843-.522 5.61z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="none"
          d="M62.256 290.414c4.297-2.534 14.341 5.423 22.49 17.786m54.942-17.786c-4.316-2.534-14.342 5.423-22.494 17.786"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#9f7e00"
        d="M170.958 222.674c-.196-.604-.564-1.144-.564-1.144 1.887-.604 4.514-.983 7.435-.99 2.922.007 5.567.386 7.453.99 0 0-.21.405-.505.968-.163.311-.378.855-.363.855-1.705-.57-3.9-.863-6.595-.866-2.7.003-5.295.364-6.647.903.02 0-.094-.34-.228-.716h.014"
      />
      <path
        fill="none"
        stroke="#000"
        d="M66.977 332.308c-.963-2.72-2.769-5.154-2.769-5.154 9.264-2.72 22.159-4.426 36.5-4.46 14.342.034 27.328 1.74 36.587 4.46 0 0-1.034 1.825-2.48 4.359-.596.96-.733 1.415-1.783 3.851-8.368-2.567-19.141-3.885-32.376-3.899-13.254.015-25.991 1.638-32.63 4.067.096 0-.46-1.533-1.121-3.224h.072"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M177.83 225.288c2.357-.004 4.952-.393 5.912-.663.639-.203 1.014-.518.944-.882-.032-.172-.17-.322-.357-.408-1.406-.492-3.941-.84-6.5-.845-2.553.004-5.1.353-6.512.845-.18.086-.323.236-.352.408-.072.364.303.679.946.882.956.27 3.563.66 5.919.663"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        d="M100.709 344.082c11.572-.019 24.314-1.772 29.023-2.989 3.137-.915 4.977-2.333 4.637-3.97-.158-.777-.839-1.452-1.754-1.84-6.902-2.213-19.347-3.784-31.906-3.804-12.536.02-25.043 1.59-31.97 3.804-.886.388-1.585 1.063-1.729 1.84-.354 1.637 1.485 3.055 4.642 3.97 4.694 1.217 17.493 2.97 29.057 2.989z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#9f7e00"
        d="m185.397 220.382-.572-.566s-.55.367-1.235.255c-.684-.112-.902-1.016-.902-1.016s-.77.7-1.395.648c-.629-.06-1.04-.648-1.04-.648s-.687.532-1.29.48c-.603-.06-1.177-.878-1.177-.878s-.602.848-1.206.907c-.603.054-1.094-.57-1.094-.57s-.276.623-1.043.762c-.766.142-1.424-.65-1.424-.65s-.432.766-.956.965c-.52.198-1.202-.286-1.202-.286s-.11.286-.193.455c-.084.169-.302.198-.302.198l.172.507c1.876-.593 4.422-.96 7.3-.964 2.88.003 5.496.371 7.371.968l.194-.567"
      />
      <path
        fill="none"
        stroke="#000"
        d="m137.86 321.986-2.811-2.549s-2.697 1.653-6.064 1.145c-3.354-.503-4.426-4.574-4.426-4.574s-3.78 3.156-6.85 2.921c-3.085-.273-5.102-2.921-5.102-2.921s-3.372 2.395-6.332 2.16c-2.96-.268-5.782-3.952-5.782-3.952s-2.955 3.818-5.92 4.086c-2.96.24-5.37-2.567-5.37-2.567s-1.356 2.806-5.12 3.43c-3.761.641-6.99-2.923-6.99-2.923s-2.122 3.444-4.694 4.34c-2.548.896-5.901-1.284-5.901-1.284s-.537 1.284-.944 2.046c-.412.761-1.485.895-1.485.895l.843 2.28c9.212-2.668 21.709-4.325 35.835-4.34 14.145.015 26.983 1.672 36.19 4.36l.948-2.553z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        d="m100.78 309.67 1.337.24c-.21.555-.254 1.145-.254 1.772 0 2.769 2.38 5.015 5.302 5.015 2.357 0 4.355-1.451 5.035-3.463.081.053.512-1.825.723-1.791.201 0 .168 1.944.216 1.91.354 2.516 2.653 4.24 5.264 4.24 2.922 0 5.293-2.246 5.293-5.015 0-.206-.015-.407-.05-.608l1.677-1.658.886 2.113c-.355.641-.498 1.384-.498 2.18 0 2.653 2.27 4.799 5.053 4.799 1.768 0 3.32-.863 4.21-2.146l1.069-1.351-.02 1.672c0 1.652.718 3.142 2.333 3.41 0 0 1.873.134 4.34-1.825 2.48-1.94 3.836-3.564 3.836-3.564l.144 1.993s-2.433 3.985-4.622 5.255c-1.212.709-3.057 1.451-4.513 1.197-1.557-.234-2.64-1.485-3.214-2.903a7.404 7.404 0 0 1-3.798 1.03c-2.994 0-5.686-1.657-6.74-4.105-1.38 1.485-3.3 2.38-5.552 2.38-2.385 0-4.58-1.062-5.959-2.734-1.35 1.25-3.185 2.012-5.207 2.012-2.634 0-5.01-1.322-6.346-3.262-1.342 1.94-3.68 3.262-6.338 3.262a7.643 7.643 0 0 1-5.202-2.012c-1.375 1.672-3.55 2.735-5.959 2.735-2.246 0-4.158-.896-5.528-2.38-1.058 2.433-3.765 4.104-6.744 4.104a7.378 7.378 0 0 1-3.784-1.03c-.57 1.418-1.672 2.669-3.21 2.903-1.46.254-3.3-.488-4.512-1.197-2.213-1.27-4.833-5.255-4.833-5.255l.34-1.993s1.35 1.624 3.818 3.564c2.476 1.96 4.35 1.825 4.35 1.825 1.623-.268 2.313-1.758 2.313-3.41v-1.672l1.058 1.35a5.157 5.157 0 0 0 4.206 2.147c2.807 0 5.068-2.146 5.068-4.8 0-.795-.143-1.538-.498-2.18l.891-2.112 1.657 1.658c-.035.2-.035.402-.035.608 0 2.769 2.357 5.015 5.255 5.015 2.63 0 4.93-1.724 5.27-4.24.071.034.05-1.91.23-1.91.234-.034.66 1.844.732 1.791.695 2.012 2.692 3.463 5.044 3.463 2.932 0 5.303-2.246 5.303-5.015 0-.627-.035-1.217-.25-1.772l1.375-.24h.035z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M177.83 220.544c-2.922.003-5.546.382-7.43.99-.128.045-.282-.06-.324-.184-.04-.13.051-.293.173-.337 1.898-.63 4.587-1.029 7.58-1.032 2.991.003 5.694.401 7.588 1.032.126.044.218.206.178.337-.04.123-.2.229-.323.184-1.887-.608-4.521-.987-7.442-.99"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        d="M100.709 322.714c-14.342.014-27.223 1.72-36.477 4.46-.623.2-1.38-.274-1.586-.83-.2-.589.25-1.317.848-1.518 9.317-2.84 22.519-4.632 37.215-4.646 14.681.014 27.95 1.806 37.247 4.646.618.201 1.069.93.872 1.518-.196.556-.982 1.03-1.585.83-9.26-2.74-22.193-4.446-36.534-4.46z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#fff"
        d="M175.003 221.672c0-.24.19-.435.425-.435a.43.43 0 0 1 .422.435c0 .244-.19.435-.422.435a.427.427 0 0 1-.425-.435"
      />
      <path
        fill="#e6e6e6"
        stroke="#000"
        d="M86.832 327.796c0-1.078.929-1.96 2.088-1.96 1.14 0 2.07.882 2.07 1.96 0 1.097-.93 1.959-2.07 1.959-1.159 0-2.088-.862-2.088-1.96z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M177.866 221.86h-.941a.328.328 0 0 1-.32-.33.32.32 0 0 1 .316-.322h1.9c.176 0 .312.145.312.322 0 .18-.14.33-.315.33z"
      />
      <path
        fill="#b50027"
        stroke="#000"
        d="M100.886 328.644h-4.618c-.857 0-1.571-.676-1.571-1.49 0-.795.695-1.451 1.552-1.451h9.331c.858 0 1.528.656 1.528 1.451 0 .814-.69 1.49-1.547 1.49z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#006f46"
        d="m173.158 222.213-.673.108a.322.322 0 0 1-.364-.273.32.32 0 0 1 .262-.368l.675-.109.69-.116a.322.322 0 0 1 .361.27.328.328 0 0 1-.265.372z"
      />
      <path
        fill="none"
        stroke="#000"
        d="m77.774 330.23-3.3.488c-.849.12-1.644-.422-1.787-1.231-.125-.795.44-1.538 1.283-1.658l3.315-.488 3.387-.522c.847-.1 1.628.421 1.772 1.216.124.79-.465 1.552-1.303 1.672z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path fill="#ce1126" d="m170.442 222.726.299-.524.64.13-.372.59z" />
      <path
        fill="#b50027"
        stroke="#000"
        d="m64.443 332.543 1.466-2.362 3.142.59-1.825 2.653z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#fff"
        d="M179.814 221.672c0-.24.192-.435.425-.435.233 0 .425.196.425.435a.43.43 0 0 1-.425.435.429.429 0 0 1-.425-.435"
      />
      <path
        fill="#e6e6e6"
        stroke="#000"
        d="M110.452 327.796c0-1.078.943-1.96 2.083-1.96 1.145 0 2.089.882 2.089 1.96 0 1.097-.944 1.959-2.089 1.959-1.14 0-2.083-.862-2.083-1.96z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#006f46"
        d="m182.506 222.213.677.108c.17.027.33-.094.359-.273a.32.32 0 0 0-.258-.368l-.676-.109-.69-.116a.318.318 0 0 0-.36.27.325.325 0 0 0 .265.372z"
      />
      <path
        fill="none"
        stroke="#000"
        d="m123.668 330.23 3.32.488c.837.12 1.618-.422 1.762-1.231.12-.795-.427-1.538-1.265-1.658l-3.32-.488-3.386-.522c-.857-.1-1.643.421-1.767 1.216-.144.79.464 1.552 1.302 1.672z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="m185.166 222.756-.24-.558-.655.06.314.626.581-.128"
      />
      <path
        fill="#b50027"
        stroke="#000"
        d="m136.615 332.522-1.068-2.36-3.219.268 1.542 2.822c.977-.219 1.917-.54 2.745-.73z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M177.826 224.692c-2.358-.004-4.49-.229-6.115-.686 1.624-.454 3.757-.735 6.115-.743 2.358.004 4.502.285 6.122.743-1.62.457-3.764.682-6.122.686"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeLinejoin="round"
        d="M100.69 341.395c-11.573-.015-22.045-1.03-30.02-3.09 7.975-2.045 18.447-3.31 30.02-3.343 11.577.014 22.101 1.284 30.053 3.343-7.952 2.06-18.476 3.075-30.054 3.09z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M185.26 219.119c.062-.2.008-.395-.128-.444-.13-.04-.286.087-.347.278-.065.203-.008.402.123.447.13.04.29-.083.353-.281"
      />
      <path
        fill="#e6e6e6"
        stroke="#000"
        d="M137.19 316.295c.302-.896.035-1.777-.632-1.998-.642-.182-1.404.393-1.706 1.25-.32.916-.04 1.811.604 2.013.642.186 1.427-.37 1.734-1.265z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M180.566 218.128c.025-.206-.07-.39-.207-.41-.135-.017-.27.14-.291.347-.025.206.065.389.204.408.138.015.268-.142.294-.345"
      />
      <path
        fill="#e6e6e6"
        stroke="#000"
        d="M114.14 311.835c.125-.929-.34-1.758-1.015-1.844-.662-.081-1.323.628-1.428 1.557-.124.93.321 1.753 1.001 1.84.676.066 1.317-.642 1.442-1.553z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M175.116 218.128c-.025-.206.064-.39.203-.41.138-.017.268.14.295.347.02.206-.07.389-.204.408-.138.015-.27-.142-.294-.345"
      />
      <path
        fill="#e6e6e6"
        stroke="#000"
        d="M87.387 311.835c-.124-.929.316-1.758.997-1.844.68-.081 1.317.628 1.446 1.557.1.93-.34 1.753-1 1.84-.676.066-1.323-.642-1.443-1.553z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M170.42 219.119c-.065-.2-.007-.395.125-.444.13-.04.29.087.352.278.061.203.007.402-.123.447-.135.04-.292-.083-.353-.281"
      />
      <g stroke="#000">
        <path
          fill="#e6e6e6"
          d="M64.337 316.295c-.32-.896-.035-1.777.609-1.998.637-.182 1.422.393 1.729 1.25.302.916.035 1.811-.604 2.013-.66.186-1.432-.37-1.734-1.265z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="m100.69 298.524-4.082 2.462 3.028 6.572 1.053.694 1.04-.694 3.046-6.572c-1.362-.82-2.71-1.664-4.086-2.462z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m91.732 308.454 1.863 2.706 6.366-1.964.676-.89-.676-.916-6.366-1.858a44.75 44.75 0 0 0-1.863 2.922zm17.948 0-1.872 2.706-6.367-1.964-.675-.89.675-.916 6.367-1.858c.654.954 1.263 1.938 1.872 2.922zm-35.556-7.008-3.2 3.022 4.1 5.408 1.087.436.805-.828 1.442-6.534a202.557 202.557 0 0 0-4.234-1.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m67.408 312.29 2.404 2.261 5.816-3.142.445-1.01-.833-.762-6.654-.575c-.444 1.057-.805 2.145-1.178 3.228zm17.551-3.53-1.231 2.99-6.659-.61-.867-.76.46-1.03 5.835-3.076c.846.803 1.651 1.647 2.462 2.486zm-23.956 4.374-.55 3.16-6.663.69-1.011-.574.254-1.078 5.006-4.158c.964.69 1.965 1.323 2.964 1.96z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path
        fill="#c8b100"
        d="M172.354 217.813c0-.274.214-.495.476-.495.265 0 .476.221.476.495 0 .27-.21.491-.476.491a.485.485 0 0 1-.476-.491"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M73.831 310.413c0-1.231 1.05-2.228 2.333-2.228 1.303 0 2.338.997 2.338 2.228 0 1.216-1.035 2.213-2.338 2.213-1.284 0-2.333-.997-2.333-2.213z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="m127.342 301.446 3.209 3.022-4.105 5.408-1.088.436-.8-.828-1.446-6.534a82.76 82.76 0 0 0 4.23-1.504z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="m134.067 312.29-2.41 2.261-5.815-3.142-.464-1.01.857-.762 6.654-.575c.463 1.072.794 2.129 1.178 3.228zm-17.556-3.53 1.231 2.99 6.658-.61.853-.76-.445-1.03-5.83-3.076c-.81.841-1.637 1.665-2.467 2.486z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path
        fill="#c8b100"
        d="m185.747 218.417.11.701 1.354.154.203-.128-.05-.24-1.017-.922-.6.435"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        d="m139.575 313.134.537 3.16 6.649.69 1-.574-.248-1.078-4.992-4.158c-.988.644-1.976 1.288-2.946 1.96z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M177.357 217.348a.48.48 0 0 1 .476-.495c.258 0 .477.217.477.495 0 .27-.216.491-.477.491a.483.483 0 0 1-.476-.491"
      />
      <path
        fill="#b50027"
        stroke="#000"
        d="M98.39 308.32c0-1.25 1.03-2.228 2.338-2.228 1.264 0 2.337.977 2.337 2.228 0 1.216-1.058 2.213-2.337 2.213-1.308 0-2.338-.997-2.338-2.213z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M182.372 217.813c0-.274.214-.495.476-.495.264 0 .48.221.48.495 0 .27-.216.491-.48.491a.485.485 0 0 1-.476-.491"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M123.007 310.413c0-1.231 1.049-2.228 2.337-2.228 1.298 0 2.357.997 2.357 2.228 0 1.216-1.059 2.213-2.357 2.213-1.288 0-2.337-.997-2.337-2.213z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M51.777 316.53a23.413 23.413 0 0 0-2.902-3.176c-.93-.829-3.21-1.538-3.21-1.538 0-.421 1.337-1.37 2.784-1.37.838 0 1.638.355 2.112.949l.168-.915s1.178.22 1.695 1.523c.537 1.35.197 3.396.197 3.396-.186.432-.574.746-.844 1.132z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M52.084 315.667c.556-.574 1.696-.455 2.534.274.858.723 1.107 1.786.546 2.38-.546.59-1.671.455-2.524-.273-.862-.723-1.107-1.806-.556-2.38z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#c8b100"
        d="M187.577 219.238c.015.011.367-.51.638-.772.185-.184.653-.342.653-.342 0-.093-.272-.304-.567-.304a.54.54 0 0 0-.432.21l-.036-.202s-.24.048-.345.338c-.109.3-.041.754-.041.754s.044.21.13.318"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        d="M148.562 316.831c.072.053 1.8-2.294 3.128-3.477.91-.829 3.209-1.538 3.209-1.538 0-.421-1.336-1.37-2.783-1.37-.838 0-1.643.355-2.122.949l-.177-.915s-1.183.22-1.696 1.523c-.531 1.35-.2 3.396-.2 3.396-.02.592.247.772.64 1.432z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#c8b100"
        d="M187.59 218.98c-.114-.128-.345-.102-.52.06-.175.16-.221.397-.113.528.113.131.345.102.519-.06.175-.16.226-.401.114-.529"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M148.624 315.667c-.56-.574-1.696-.455-2.553.274-.858.723-1.087 1.786-.556 2.38.556.59 1.696.455 2.549-.273.857-.723 1.11-1.806.56-2.38z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#0044ad"
          d="M102.502 272c2.416.654 4.171 2.785 4.171 5.296 0 3.046-2.607 5.513-5.85 5.513-3.218 0-5.825-2.467-5.825-5.513 0-2.556 1.825-4.686 4.311-5.341"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M106.864 275.85v2.754H94.807v-2.754h4.46v-6.218H96.32v-2.768h2.946v-2.721h2.907v2.72h2.903v2.77h-2.903v6.217h3.65z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="none">
          <path
            strokeWidth={0.1}
            d="M100.376 341.444v-6.03m-1.638 6.03v-6.03"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.25}
            d="M97.192 341.444v-6.03m-1.532 6.03v-6.03m-1.366 6.03v-6.03m-2.605 5.706-.036-5.49m1.27 5.562v-5.742"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.5}
            d="M89.284 340.873v-5.057m1.218 5.201-.036-5.382m-4.408 4.948v-4.442m1.059 4.515v-4.66m1.09 4.805v-4.841"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.75}
            d="M84.927 340.547v-4.298m-1.054 4.387v-4.703m-1.131 4.567v-4.387m-2.315 4.007-.036-3.712m1.222 3.939v-4.1"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M79.24 340.033v-3.35m-1.086 3.388v-3.219m-1.187 2.598v-2.418m-1.219 2.44v-2.207m-1.291 1.919v-1.64"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={0.1}
            d="M106.892 341.12v-5.525m-2.774 5.705.036-5.85m-2.058 5.922v-5.958"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path fill="#9f7e00" d="M166.944 231.292h21.597v-6.17h-21.597z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M47.27 371.123h106.024v-27.792H47.27z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M169.21 235.399c.135-.06.234-.067.4-.067h16.174c.16 0 .312.03.439.086a1.478 1.478 0 0 1-.951-1.395c0-.645.432-1.204.991-1.414a1.56 1.56 0 0 1-.468.086H169.61c-.164 0-.32-.007-.454-.056l.087.015c.577.194.908.754.908 1.369 0 .592-.367 1.185-.941 1.376"
      />
      <g fill="#9f7e00">
        <path
          stroke="#000"
          strokeLinejoin="round"
          strokeWidth={1.857}
          d="M58.398 389.618c.66-.269 1.144-.302 1.964-.302h79.396c.785 0 1.532.134 2.155.388-2.711-.91-4.67-3.377-4.67-6.285 0-2.902 2.122-5.422 4.866-6.366-.622.202-1.552.388-2.299.388H60.362c-.805 0-1.572-.033-2.228-.254l.426.067c2.836.877 4.46 3.397 4.46 6.165 0 2.668-1.801 5.341-4.622 6.199z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path d="M169.61 235.332h16.174c.548 0 .991.371.991.825 0 .458-.443.829-.99.829H169.61c-.549 0-.993-.371-.993-.829 0-.454.444-.825.993-.825" />
        <path
          stroke="#000"
          strokeWidth={1.857}
          d="M60.362 389.316h79.396c2.692 0 4.866 1.672 4.866 3.717 0 2.06-2.174 3.731-4.866 3.731H60.362c-2.692 0-4.872-1.671-4.872-3.731 0-2.045 2.18-3.717 4.872-3.717z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#dead00"
        d="M169.61 231.292h16.185c.545 0 .992.315.992.698 0 .39-.447.705-.992.705H169.61c-.549 0-.993-.315-.993-.705 0-.383.444-.698.993-.698"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M60.362 371.123h79.448c2.678 0 4.872 1.418 4.872 3.143 0 1.753-2.194 3.175-4.872 3.175H60.362c-2.692 0-4.872-1.422-4.872-3.175 0-1.725 2.18-3.143 4.872-3.143z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M169.21 324.683c.052.214.125.424.125.653 0 1.545-1.225 2.775-2.722 2.775h22.227c-1.498 0-2.722-1.23-2.722-2.775 0-.225.04-.44.091-.653a1.22 1.22 0 0 1-.425.056H169.61c-.131 0-.283-.014-.4-.056"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.857}
        d="M58.398 791.733c.254.963.608 1.911.608 2.941 0 6.96-6.012 12.497-13.36 12.497H154.76c-7.353 0-13.364-5.537-13.364-12.497 0-1.015.196-1.978.45-2.941-.628.22-1.375.254-2.089.254H60.362c-.642 0-1.39-.067-1.964-.254z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#dead00"
        d="M169.61 323.082h16.174c.548 0 .991.375.991.829 0 .457-.443.828-.99.828H169.61c-.549 0-.993-.37-.993-.828 0-.454.444-.83.993-.83"
      />
      <path
        fill="#9f7e00"
        stroke="#000"
        strokeWidth={1.857}
        d="M60.362 784.52h79.396c2.692 0 4.866 1.69 4.866 3.735 0 2.06-2.174 3.732-4.866 3.732H60.362c-2.692 0-4.872-1.672-4.872-3.732 0-2.045 2.18-3.736 4.872-3.736z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path fill="#9f7e00" d="M166.642 334.274h22.169v-6.163h-22.169z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M45.79 834.93h108.826v-27.76H45.79z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M164.908 301.27c-2.194 1.381-3.68 2.795-3.44 3.5.12.649.818 1.133 1.813 1.853 1.566 1.189 2.518 3.312 1.773 4.291a6.292 6.292 0 0 0 2.118-4.737c0-1.98-.864-3.766-2.264-4.906"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M37.278 686.29c-10.773 6.217-18.068 12.583-16.89 15.759.59 2.922 4.014 5.101 8.9 8.344 7.688 5.355 12.363 14.916 8.704 19.328 6.37-5.135 10.4-12.804 10.4-21.335 0-8.919-4.245-16.962-11.114-22.096z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path fill="#b2b2b2" d="M169.818 322.084h15.751v-84.119h-15.751z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M116.497 401.698v378.026m8.684-378.026v378.026m-63.804.302h77.327v-378.85H61.377z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b50027"
        d="M201.659 269.43c-3.437-1.549-9.28-2.696-15.984-2.937-2.31.02-4.887.256-7.547.74-9.422 1.713-16.599 5.813-16.028 9.151.011.072.032.217.047.281 0 0-3.531-8.675-3.59-9.005-.628-3.705 7.333-8.26 17.79-10.161a49.598 49.598 0 0 1 9.262-.799c6.69 0 12.504.934 16.006 2.351l.044 10.379"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.857}
        d="M217.688 542.885c-16.871-6.974-45.554-12.143-78.467-13.225-11.343.086-23.989 1.15-37.047 3.329-46.253 7.717-81.484 26.182-78.682 41.218.053.321.158.977.23 1.265 0 0-17.335-39.073-17.623-40.558-3.085-16.688 35.998-37.2 87.333-45.764 16.11-2.687 31.821-3.731 45.468-3.597 32.841 0 61.38 4.206 78.572 10.59l.216 46.742"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M169.792 279.989c-4.367-.342-7.35-1.614-7.692-3.605-.27-1.586 1.206-3.341 3.845-4.935 1.177.138 2.503.314 3.873.314l-.026 8.226"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M61.253 590.44c-21.441-1.537-36.084-7.266-37.76-16.233-1.323-7.147 5.92-15.05 18.872-22.23 5.777.622 12.287 1.417 19.012 1.417l-.124 37.047"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#ce1126"
        d="M185.598 273.56c2.729.45 4.779 1.189 5.8 2.097l.09.183c.487 1.088-1.91 3.402-5.915 5.987l.025-8.267"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={1.857}
        d="M138.847 561.485c13.394 2.026 23.458 5.355 28.468 9.446l.445.824c2.39 4.9-9.379 15.323-29.037 26.963l.124-37.233"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b50027"
        d="M160.007 296.215c-.414-1.359 3.845-4.077 9.865-6.485 2.751-1.073 5.021-2.19 7.837-3.545 8.362-4.029 14.54-8.653 13.78-10.34l-.084-.173c.447.393 1.137 8.7 1.137 8.7.763 1.546-4.89 6.104-12.59 10.125-2.464 1.283-7.667 3.379-10.124 4.317-4.393 1.661-8.76 4.793-8.36 5.956l-1.46-8.551"
      />
      <g stroke="#000">
        <path
          fill="none"
          strokeLinejoin="round"
          strokeWidth={1.857}
          d="M13.217 663.518c-2.035-6.117 18.873-18.36 48.428-29.205 13.504-4.833 24.65-9.868 38.474-15.966 41.047-18.144 71.373-38.971 67.641-46.573l-.407-.776c2.194 1.772 5.58 39.187 5.58 39.187 3.747 6.96-24.007 27.486-61.806 45.597C99.032 661.559 73.491 671 61.43 675.225c-21.565 7.482-43.006 21.588-41.042 26.824l-7.17-38.512v-.02z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          strokeWidth={0.5}
          d="M56.046 524.712c9.455-3.45 15.644-7.52 12.612-14.97-1.911-4.727-6.797-5.642-14.092-2.97l-12.934 4.695 11.65 28.702c1.264-.575 2.529-1.169 3.851-1.657 1.303-.474 2.678-.829 4.014-1.217l-5.101-12.57v-.014zm-5.62-13.853 3.263-1.183c2.711-.997 5.782.44 7.137 3.784 1.016 2.553.747 5.389-2.37 7.381-1.021.628-2.195 1.097-3.34 1.557zm35.836-12.009c-1.356.37-2.712.776-4.086 1.044-1.37.273-2.783.422-4.172.609l6.706 29.851 20.851-4.191c-.25-.59-.57-1.217-.695-1.825-.143-.623-.124-1.317-.162-1.94-3.655 1.044-7.65 2.18-12.45 3.142l-5.973-26.69m41.741 25.742c3.942-10.826 8.703-21.201 13.393-31.706-.838.134-1.73.254-2.568.302-.838.053-1.748.067-2.586.035-2.496 7.621-5.6 15.238-8.867 22.825-3.923-7.2-8.258-14.226-11.558-21.474-1.624.206-3.281.44-4.924.56-1.62.101-3.315.082-4.94.101 6.012 9.796 11.809 19.563 17.303 29.665.766-.14 1.552-.321 2.385-.374.771-.052 1.576.02 2.362.053m43.594-22.96c.729-1.452 1.461-2.874 2.28-4.225-1.12-1.064-4.564-2.615-8.598-3.023-8.507-.843-13.393 2.941-13.963 8.076-1.197 10.744 15.764 9.815 14.984 16.943-.34 3.075-3.607 4.325-7.066 3.985-3.87-.388-6.687-2.515-7.19-5.676l-1.049-.1c-.555 1.877-1.375 3.683-2.251 5.489 2.476 1.604 5.71 2.52 8.795 2.821 8.67.862 15.29-2.615 15.912-8.325 1.126-10.208-15.999-10.797-15.342-16.808.287-2.534 2.232-4.192 6.653-3.75 3.176.32 5.14 2.04 5.997 4.507l.838.086"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path
        fill="#005bbf"
        d="M192.818 335.133c-1.493 0-2.823-.342-3.804-.912-.974-.54-2.292-.87-3.746-.87-1.46 0-2.812.334-3.786.878-.978.56-2.33.904-3.805.904-1.494 0-2.822-.38-3.804-.949-.966-.518-2.26-.833-3.677-.833-1.465 0-2.765.304-3.739.855-.982.567-2.34.927-3.83.927v2.55c1.49 0 2.848-.371 3.83-.934.974-.548 2.275-.858 3.74-.858 1.412 0 2.706.318 3.676.84.978.566 2.31.952 3.804.952 1.476 0 2.827-.352 3.805-.907.974-.551 2.325-.885 3.786-.885 1.454 0 2.772.334 3.746.877.981.57 2.289.915 3.787.915l.017-2.55"
      />
      <path
        fill="#0044ad"
        stroke="#000"
        strokeWidth={1.857}
        d="M174.29 838.795c-7.33 0-13.858-1.537-18.677-4.105-4.78-2.433-11.252-3.918-18.39-3.918-7.17 0-13.805 1.504-18.585 3.952-4.8 2.52-11.434 4.071-18.677 4.071-7.333 0-13.857-1.705-18.676-4.272-4.742-2.333-11.094-3.751-18.05-3.751-7.19 0-13.575 1.37-18.355 3.851-4.819 2.553-11.487 4.172-18.801 4.172v11.487c7.314 0 13.982-1.672 18.801-4.206 4.78-2.467 11.166-3.865 18.356-3.865 6.936 0 13.287 1.432 18.049 3.784 4.8 2.548 11.343 4.287 18.676 4.287 7.243 0 13.877-1.586 18.677-4.086 4.78-2.481 11.415-3.985 18.586-3.985 7.137 0 13.608 1.504 18.389 3.951 4.819 2.568 11.237 4.12 18.59 4.12l.086-11.487z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b2b2b2"
        d="M192.818 337.683c-1.493 0-2.823-.345-3.804-.915-.974-.543-2.292-.877-3.746-.877-1.46 0-2.812.334-3.786.885-.978.555-2.33.907-3.805.907-1.494 0-2.822-.386-3.804-.952-.966-.522-2.26-.84-3.677-.84-1.465 0-2.765.31-3.739.858-.982.563-2.34.934-3.83.934v2.543c1.49 0 2.848-.364 3.83-.926.974-.555 2.275-.863 3.74-.863 1.412 0 2.706.32 3.676.84.978.567 2.31.949 3.804.949 1.476 0 2.827-.352 3.805-.907.974-.548 2.325-.882 3.786-.882 1.454 0 2.772.334 3.746.878.981.566 2.289.911 3.787.911l.017-2.543"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M174.29 850.282c-7.33 0-13.858-1.552-18.677-4.12-4.78-2.447-11.252-3.951-18.39-3.951-7.17 0-13.805 1.504-18.585 3.985-4.8 2.5-11.434 4.086-18.677 4.086-7.333 0-13.857-1.739-18.676-4.287-4.742-2.352-11.094-3.784-18.05-3.784-7.19 0-13.575 1.398-18.355 3.865-4.819 2.534-11.487 4.206-18.801 4.206v11.453c7.314 0 13.982-1.638 18.801-4.172 4.78-2.5 11.166-3.885 18.356-3.885 6.936 0 13.287 1.437 18.049 3.784 4.8 2.553 11.343 4.273 18.676 4.273 7.243 0 13.877-1.586 18.677-4.086 4.78-2.467 11.415-3.971 18.586-3.971 7.137 0 13.608 1.504 18.389 3.952 4.819 2.553 11.237 4.105 18.59 4.105l.086-11.453"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#005bbf"
        d="M192.818 340.226c-1.493 0-2.823-.345-3.804-.911-.974-.544-2.292-.878-3.746-.878-1.46 0-2.812.334-3.786.882-.978.555-2.33.907-3.805.907-1.494 0-2.822-.382-3.804-.949-.966-.52-2.26-.84-3.677-.84-1.465 0-2.765.307-3.739.863-.982.562-2.34.926-3.83.926v2.543c1.49 0 2.848-.364 3.83-.93.974-.547 2.275-.854 3.74-.854 1.412 0 2.706.318 3.676.835.978.57 2.31.949 3.804.949 1.476 0 2.827-.348 3.805-.903.974-.548 2.325-.881 3.786-.881 1.454 0 2.772.329 3.746.874.981.573 2.289.91 3.787.91l.017-2.543"
      />
      <path
        fill="#0044ad"
        stroke="#000"
        strokeWidth={1.857}
        d="M174.29 861.735c-7.33 0-13.858-1.552-18.677-4.105-4.78-2.448-11.252-3.952-18.39-3.952-7.17 0-13.805 1.504-18.585 3.97-4.8 2.501-11.434 4.087-18.677 4.087-7.333 0-13.857-1.72-18.676-4.273-4.742-2.347-11.094-3.784-18.05-3.784-7.19 0-13.575 1.384-18.355 3.885-4.819 2.534-11.487 4.172-18.801 4.172v11.453c7.314 0 13.982-1.638 18.801-4.187 4.78-2.467 11.166-3.85 18.356-3.85 6.936 0 13.287 1.436 18.049 3.764 4.8 2.568 11.343 4.273 18.676 4.273 7.243 0 13.877-1.567 18.677-4.067 4.78-2.467 11.415-3.97 18.586-3.97 7.137 0 13.608 1.484 18.389 3.937 4.819 2.581 11.237 4.1 18.59 4.1l.086-11.453"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b2b2b2"
        d="M192.8 345.316c-1.497 0-2.805-.344-3.786-.915-.974-.54-2.292-.87-3.746-.87-1.46 0-2.812.33-3.786.878-.978.555-2.33.907-3.805.907-1.494 0-2.822-.383-3.804-.953-.966-.517-2.26-.832-3.677-.832-1.465 0-2.765.308-3.739.854-.982.568-2.34.931-3.83.931v-2.531c1.49 0 2.848-.38 3.83-.946.974-.547 2.275-.854 3.74-.854 1.412 0 2.706.318 3.676.835.978.57 2.31.949 3.804.949 1.476 0 2.827-.348 3.805-.903.974-.548 2.325-.881 3.786-.881 1.454 0 2.772.329 3.746.874.981.573 2.311.91 3.804.91l-.017 2.547"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.857}
        d="M174.203 884.66c-7.353 0-13.771-1.552-18.59-4.12-4.78-2.433-11.252-3.922-18.39-3.922-7.17 0-13.805 1.49-18.585 3.956-4.8 2.5-11.434 4.086-18.677 4.086-7.333 0-13.857-1.724-18.676-4.292-4.742-2.328-11.094-3.75-18.05-3.75-7.19 0-13.575 1.389-18.355 3.85-4.819 2.554-11.487 4.192-18.801 4.192v-11.4c7.314 0 13.982-1.71 18.801-4.259 4.78-2.467 11.166-3.85 18.356-3.85 6.936 0 13.287 1.436 18.049 3.764 4.8 2.568 11.343 4.273 18.676 4.273 7.243 0 13.877-1.567 18.677-4.067 4.78-2.467 11.415-3.97 18.586-3.97 7.137 0 13.608 1.484 18.389 3.937 4.819 2.581 11.347 4.1 18.676 4.1l-.086 11.472"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#005bbf"
        d="M192.8 347.863c-1.497 0-2.805-.345-3.786-.911-.974-.548-2.292-.882-3.746-.882-1.46 0-2.812.338-3.786.885-.978.555-2.33.908-3.805.908-1.494 0-2.822-.387-3.804-.953-.966-.52-2.26-.84-3.677-.84-1.465 0-2.765.312-3.739.863-.982.562-2.34.93-3.83.93v-2.524c1.49 0 2.848-.387 3.83-.953.974-.547 2.275-.851 3.74-.851 1.412 0 2.706.315 3.676.832.978.566 2.31.95 3.804.95 1.476 0 2.827-.353 3.805-.908.974-.548 2.325-.874 3.786-.874 1.454 0 2.772.326 3.746.87.981.567 2.304.911 3.8.911l-.013 2.547"
      />
      <path
        fill="#0044ad"
        stroke="#000"
        strokeWidth={1.857}
        d="M174.203 896.132c-7.353 0-13.771-1.557-18.59-4.105-4.78-2.467-11.252-3.97-18.39-3.97-7.17 0-13.805 1.518-18.585 3.984-4.8 2.5-11.434 4.091-18.677 4.091-7.333 0-13.857-1.743-18.676-4.292-4.742-2.347-11.094-3.784-18.05-3.784-7.19 0-13.575 1.404-18.355 3.885-4.819 2.534-11.487 4.191-18.801 4.191v-11.371c7.314 0 13.982-1.74 18.801-4.292 4.78-2.462 11.166-3.832 18.356-3.832 6.936 0 13.287 1.418 18.049 3.75 4.8 2.549 11.343 4.273 18.676 4.273 7.243 0 13.877-1.586 18.677-4.086 4.78-2.467 11.415-3.937 18.586-3.937 7.137 0 13.608 1.47 18.389 3.918 4.819 2.553 11.31 4.105 18.657 4.105z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b2b2b2"
        d="M250.2 349.559c-12.677 0-25.242-3.388-35.806-9.021-7.786-4.205-12.95-12.681-12.95-22.381v-35.175h97.319v35.175c0 9.7-5.163 18.176-12.95 22.38-10.563 5.634-22.932 9.022-35.613 9.022"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.465}
        d="M455.98 903.768c-62.232 0-123.914-15.257-175.772-40.63-38.225-18.935-63.57-57.112-63.57-100.797V603.92H694.38v158.42c0 43.685-25.344 81.862-63.574 100.797-51.853 25.373-112.572 40.63-174.824 40.63z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#b50027"
        d="M250.03 318.115c0 13.901-10.807 25.169-24.269 25.169-13.467 0-24.381-11.268-24.381-25.169v-35.227h48.65z"
      />
      <g stroke="#000">
        <g fill="#a07e00">
          <path
            fill="#9f7e00"
            strokeWidth={2.465}
            d="M268.491 855.7c7.463 3.96 17.714 10.557 28.664 13.196l-.694-270.988h-27.97z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            strokeLinejoin="round"
            strokeWidth={2.387}
            d="M215.925 760.018c.728 33.435 14.001 58.29 27.275 74.567v-235.36h-26.94z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            strokeWidth={2.465}
            d="M321.738 874.836c10.946 1.101 19.108.881 27.97 0V597.908h-27.97zm52.562-5.94c10.95-2.199 23.294-9.015 28.669-12.536V597.908h-27.97zm54.66-36.951c11.645-10.336 22.595-33.875 26.575-60.709l.695-173.328h-27.97z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="none"
          strokeWidth={2.465}
          d="M455.143 762.154c0 62.606-53.05 113.352-119.135 113.352-66.108 0-119.69-50.746-119.69-113.352V603.498h238.825z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
      </g>
      <path fill="#b50027" d="M201.382 282.922h48.629v-58.85h-48.629z" />
      <g stroke="#000">
        <path
          fill="#2b1100"
          strokeMiterlimit={3.864}
          strokeWidth={0.045}
          d="M263.632 553.228v-19.305h20.788l-.116-34.06-.115-34.06-10.166-.252.001-10.082c.001-5.544.135-13.226.297-17.07l.295-6.99 2.301-.002c1.266-.001 4.589-.132 7.384-.29l5.083-.288v-16.728h-9.488l.002-5.658c.001-3.112.134-7.606.294-9.985l.292-4.327h8.448v1.95c0 2.105.416 2.488 2.71 2.488 2.295 0 2.711-.383 2.711-2.489v-1.95h12.096l.299 1.958c.32 2.1.802 2.48 3.139 2.48 1.9 0 2.538-.69 2.538-2.75v-1.687h8.584v19.94l-9.714.252-.123 8.321-.122 8.321h13.573v-41.272h-9.036v-19.971h9.067l-.3 2.22-.299 2.218h1.583c.87 0 2.218-.125 2.995-.277 1.323-.26 1.412-.4 1.412-2.219v-1.942h11.746v1.909c0 2.386.587 2.973 2.972 2.973 2.216 0 2.69-.455 3.116-2.995l.317-1.887h8.504v19.971h-9.487v41.272h11.315l-.246-16.642-8.81-.254.04-8.083c.021-4.446.174-9.082.338-10.302l.3-2.219 4.179-.128 4.179-.127v2.147c0 2.516.55 3.212 2.538 3.212 2.414 0 2.842-.367 3.158-2.707l.293-2.175h3.493c1.922 0 4.437-.127 5.59-.282l2.096-.283v5.447h2.655c2.98 0 3.524-.383 3.746-2.636.171-1.742.58-1.923 5.458-2.41l3.05-.305v20.318l-2.096.283c-1.153.155-3.288.282-4.744.282h-2.648v16.727l5.493.29c3.02.16 6.782.29 8.358.29h2.866v8.765c.001 4.821.135 12.503.297 17.07l.296 8.306-4.928.126-4.928.127v67.9l9.601.12 9.6.119v38.592h-144.12z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          strokeWidth={1.5}
          d="M285.557 464.162v71.031l-19.923.06v36.55l140.116-.204v-36.55l-19.27-.073v-70.814z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="m265.634 571.804 138.591-.205M265.58 562.79l140.031-.124m-139.977-8.839 139.977.123m-140.031-8.882 140.031-.123m-139.955-9.68 140.11-.289m-119.883-9.426 100.652-.05m-100.978-9.183H386.48m-100.923-7.851H386.48m-100.923-8.861H386.48m-100.923-8.861H386.48"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M285.557 481.884H386.48"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M365.649 473.24v8.384m-80.092-8.601H386.48"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M285.557 571.6v-8.862"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M285.557 553.878v-8.861m-8.873 8.861v8.86"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M295.502 562.738v-8.86"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M305.946 535.048v-9.477m.154-9.306-.154-7.799m-10.444 36.551v-9.969"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M276.684 545.017v-9.969"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M295.502 516.317v8.86m20.094-8.86v8.86m19.836-8.686.077 9.11m-10.19-9.047v-8.088m10.221-8.861v8.861m-9.948-35.443v8.86m10-17.721v8.86m-19.996-8.86v8.86m-18.966-8.86v8.86m89.85 98.578v-8.862m0-8.86v-8.861m8.873 8.861v8.86m-19.999 0v-8.86m-9.62-18.83-.054-9.594m0-9.065v-7.923"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M375.354 545.017v-9.969"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M395.353 545.017v-9.969"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="m375.361 516.286.11 9.27"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M355.365 516.286v9.27m-9.557-9.146v-7.944m0-17.658v8.861"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M335.318 481.884v8.86"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="M345.808 473.023v8.86m9.557-17.312v8.282m19.989-8.294v8.307m-50.035 26.739v-8.86"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g transform="matrix(.2037 0 0 .22204 156.38 147.807)">
            <path d="M360.089 576.487v-23.968c0-4.565-1.954-18.26-20.512-18.26-17.582 0-19.536 13.695-19.536 18.26v23.968z" />
            <path d="m350.622 558.815 19.517.093-.022-9.13-6.634-9.914-13.521 9.553c1.412 3.36.66 7.181.66 9.397zm-4.987-14.151 4.34-14.155-20.093-.121 4.646 14.017c3.676-.739 7.47-.65 11.107.26zm14.829-31.314v-20.903c0-5.701 3.531-10.452 9.71-10.452s9.71 4.75 9.71 10.452v20.903z" />
            <rect
              width={19.405}
              height={8.766}
              x={310.536}
              y={567.607}
              rx={0.036}
            />
            <path d="M350.785 567.64h19.519v8.766h-19.519zm-20.894-9.015-19.354.186.17-9.021 5.743-9.563 13.781 9.056c-.835 3.685-.259 3.489-.34 9.342z" />
          </g>
          <path
            d="M305.786 473.243v8.386M295.524 508.503V487.45c0-5.742 3.673-10.527 10.102-10.527s10.103 4.785 10.103 10.527v21.054z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="#9f7e00"
          strokeWidth={2.746}
          d="M-614.733 43.702h35.54v98.378h-35.54zm61.549-44.729h35.386v143.03h-35.386zm58.937 44.729h35.54v98.378h-35.54z"
          transform="matrix(.11481 0 0 .11757 287.167 235.476)"
        />
        <g fill="#9f7e00">
          <path
            d="m325.979 435.777 19.754.036m-19.963 7.456 19.755.036m13.395-25.327h19.794m-19.867 9.823h19.794m-19.794 7.668h19.794m-19.486 8.245h19.794m-10.051-25.911v-4.776m.077 22.14v-7.209m-.231 23.122v-7.21m-77.806-8.047h19.794m-19.486 8.246h19.794"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fillRule="evenodd"
            strokeWidth={1.5}
            d="M275.869 465.274v-32.938l15.048-.085 4.47 2.914.192 15.958 12.687.035-.103-16.474 3.856-2.552 12.99-.013 4.432 3.286-.039 15.801 13.131.049.192-15.646 3.357-3.418 12.899-.012 3.92 3.19.512 15.32 11.978.06-.218-15.14 4.138-3.478 16.55.048v32.855z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M275.74 455.734h119.92m-110.12.034v9.505m20.263-9.6v9.505"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="#dead00"
          d="M325.838 455.776v9.504"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M345.819 455.725v9.504m19.871-9.453v9.504m20.787-9.534v9.504m-90.964-18.809v9.504m-.256-18.519H275.93m19.446 9.651h-19.325m53.243-9.718h-21.02m54.676-.03-20.403-.072m53.324 0H375.16m-45.923 9.82-21.097-.073m55.066.073h-20.634m53.153-.03-20.48-.073m-89.743-9.382v9.505m30.105-.065.038 8.817m10.192-18.485.022 9.595m19.957-9.544.022 9.595m40.656-9.91.022 9.92m-71.006-14.783.022 5.273"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M335.592 451.216v4.539"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="m355.376 447.058.038 8.528m-.134-23.613.022 5.274"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="m375.365 446.984.039 8.744"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#0044ad" strokeWidth={1.831}>
          <path
            strokeWidth={2.746}
            d="M-239.334 350.749V313.02c0-6.288 1.32-25.249-19.543-23.607-21.22-1.224-17.401 17.32-17.401 23.607v37.729z"
            transform="matrix(.11481 0 0 .11757 255.297 234.577)"
          />
          <path
            d="M-195.138 224.826v-29.623c0-7.795-3.178-15.591-9.534-15.591-6.357 0-9.535 7.795-9.535 15.59v29.624zm-106.513-.317v-29.623c0-7.795-3.178-15.591-9.535-15.591-6.356 0-9.534 7.795-9.534 15.59v29.624z"
            transform="matrix(.11481 0 0 .11757 255.297 234.577)"
          />
        </g>
        <path
          fill="#9f7e00"
          d="m325.652 428.106 19.755.036m-19.755-9.688 19.755.036m-19.755-8.195 19.755.036m-19.755-8.628 19.755.036m-19.755-7.594 20.19.036m-10.262 7.531v-7.647"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M335.58 418.138v-7.647"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#9f7e00"
          d="M335.58 435.834v-7.647m0 22.786v-7.647m-44.57-24.993h19.795m-19.867 9.823h19.794m-9.743-9.999v-5.029m.077 22.394v-7.21"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#dead00">
          <path
            d="M300.835 451.435v-7.21"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g strokeWidth={1.831}>
            <path
              fill="#9f7e00"
              strokeWidth={2.746}
              d="m-291.456-29.178-.298 35.88 68.693-.274-.23-35.41-11.905.273-.547 8.773-12.775-.273v-8.608h-17.75v8.608h-13.156l.273-8.97z"
              transform="matrix(.11481 0 0 .11757 255.297 234.577)"
            />
            <path
              d="m-291.44-8.428 68.606.067m-35.177 14.839V-7.964"
              transform="matrix(.11481 0 0 .11757 255.297 234.577)"
            />
            <path
              fill="#9f7e00"
              strokeWidth={2.746}
              d="m-291.456-29.178-.298 35.88 68.693-.274-.23-35.41-11.905.273-.547 8.773-12.775-.273v-8.608h-17.75v8.608h-13.156l.273-8.97z"
              transform="matrix(.11481 0 0 .11757 248.195 239.963)"
            />
            <path
              d="m-291.44-8.428 68.606.067m-35.177 14.839V-7.964"
              transform="matrix(.11481 0 0 .11757 248.195 239.963)"
            />
            <path
              fill="#9f7e00"
              strokeWidth={2.746}
              d="m-291.456-29.178-.298 35.88 68.693-.274-.23-35.41-11.905.273-.547 8.773-12.775-.273v-8.608h-17.75v8.608h-13.156l.273-8.97z"
              transform="matrix(.11481 0 0 .11757 262.124 239.91)"
            />
            <path
              d="m-291.44-8.428 68.606.067m-35.177 14.839V-7.964"
              transform="matrix(.11481 0 0 .11757 262.124 239.91)"
            />
          </g>
        </g>
        <g fill="none">
          <path
            strokeWidth={2.465}
            d="M216.332 603.652h238.72V338.604h-238.72z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            strokeWidth={1.067}
            d="m620.122 669.574-8.51-3.532-15.38 17.358 5.157 7.298zm6.624 5.28 5.152 7.319-15.375 17.357-8.49-3.552z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="#b60028"
          strokeWidth={2.465}
          d="M694.595 603.498v158.656c0 62.606-53.654 113.352-119.762 113.352-66.09 0-119.69-50.746-119.69-113.352V603.498z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g strokeWidth={1.067}>
          <path
            fill="#9f7e00"
            d="M490.072 619.628c-7.651 0-13.838 5.909-13.838 13.171 0 5.76 3.893 10.736 9.337 12.505v20.507l-8.837 2.5v22.675l8.67 2.5v-7.335h.167V672.98h8.503v-27.51c.363-.107.986-.205 1.334-.333l27.175 30.51-5.001 7.503 15.505 17.172 8.503-3.668 21.507 24.175c-.368.65-.588 1.296-.833 2h-14.005l-2.501-8.502h-23.841l-2.668 8.503H502.91c-1.313-4.048-4.589-7.33-8.836-8.67v-28.01h-8.503v7.337h-.167l.167 20.673c-4.697 1.416-8.43 5.028-9.503 9.67-.01.05.01.116 0 .167-.154.8-.334 1.637-.334 2.5 0 5.873 4.063 10.828 9.67 12.505v13.338l-8.836 3 1.334 22.675 8.836 2c1.19 6.294 3.128 12.267 5.669 18.007l-.667.833c-4.989 5.5-4.327 13.784 1.5 18.507 3.767 3.066 8.755 3.799 13.171 2.5 3.834 4.307 8.176 8.3 12.838 11.838l-2 8.836c6.434 4.33 13.382 8.082 20.84 10.837l6.669-6.335a94.981 94.981 0 0 0 17.172 4.001c1.375 5.893 6.86 10.337 13.505 10.337 6.66 0 12.17-4.408 13.504-10.337 5.532-.833 11.024-2.097 16.172-3.834l-.167-.167c2.329-.794 4.596-1.536 6.836-2.501l-4.168-7.336c4.25-1.809 8.336-3.892 12.17-6.336l4.169 7.17c-3.87 2.402-7.923 4.672-12.171 6.502-2.21.948-4.36 1.888-6.669 2.667l6.502 6.169c7.463-2.755 14.406-6.508 20.84-10.837l-1.833-8.836c4.62-3.519 8.865-7.563 12.67-11.838 4.396 1.299 9.41.566 13.172-2.5 5.827-4.723 6.625-13.007 1.667-18.507l-.834-.833c2.549-5.74 4.49-11.713 5.669-18.007l8.836-2 1.334-22.675-8.836-3v-13.338c5.617-1.677 9.67-6.632 9.67-12.505 0-.863-.15-1.7-.334-2.5-.01-.053.01-.115 0-.167-1.078-4.64-4.797-8.255-9.503-9.67l.167-20.674 8.836-2.5V668.31l-8.836-2.5v-20.508c5.632-1.681 9.67-6.6 9.67-12.504 0-7.263-6.187-13.17-13.839-13.171-6.164 0-11.366 3.88-13.17 9.17H623.45v8.17h-14.004v-8.17h-21.34c-1.81-5.29-7.003-9.17-13.172-9.17-6.17 0-11.362 3.88-13.171 9.17h-21.007v8.17H526.75v-8.17h-23.508c-1.794-5.29-6.987-9.17-13.171-9.17z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#c8b100"
            d="m521.583 620.295-2.501 8.336h29.01l-2.501-8.336zm83.195 0-2.668 8.336h29.01l-2.5-8.336zm-114.706 6.835c3.271 0 6.002 2.567 6.002 5.67 0 3.107-2.73 5.668-6.002 5.668-3.276 0-6.002-2.561-6.002-5.669 0-3.102 2.726-5.668 6.002-5.668z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M503.41 636.968h15.672l2.5 8.502h24.009l2.5-8.502h13.672c1.406 4.068 4.72 7.235 9.003 8.502v9.67l-8.836 2.501v22.675l8.836 2.5v31.511c-.47.164-1.045.447-1.5.667l-21.174-23.675 5.168-7.336-15.672-17.339-8.336 3.668-27.342-30.343a12.309 12.309 0 0 0 1.5-3.001z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M587.939 636.968h14.171l2.668 8.502h23.841l2.501-8.502h15.839c.189.582.567.979.833 1.5l-27.676 31.177-8.503-3.5-15.338 17.338 5.168 7.336 5.002-5.502 8.836-10.17 6.67 5.335-13.839 15.672 8.336 3.501 15.506-17.339-5.169-7.336 27.01-30.51c.613.307 1.174.63 1.833.834v20.507l-9.003 2.5v22.675l9.003 2.5v20.841c-4.221 1.34-7.522 4.455-8.836 8.503h-15.839l-2.667-8.503h-23.842l-2.5 8.503h-13.338c-.363-1.155-.67-2.192-1.334-3.168l20.84-23.508 4.835-5.668-6.502-5.169-25.675 29.177c-.384-.113-1.118-.226-1.5-.334v-38.68h-8.504v-13.17h8.67v20.506l8.836-2.5V657.64l-8.836-2.5v-9.837c4.094-1.32 7.148-4.416 8.503-8.337z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#c8b100"
            d="M494.24 665.81v27.677l8.837-2.501V668.31z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M655.628 672.98h8.67v13.17h-8.67zm-121.541 2.834 9.003 10.003-6.502 5.336-9.17-10.17z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#c8b100"
            d="M489.739 720.996c2.265 0 4.177 1.178 5.168 2.834.02.045-.02.12 0 .167.364.817.667 1.631.667 2.5 0 3.118-2.539 5.67-5.835 5.67-3.277 0-6.002-2.552-6.002-5.67 0-.864.299-1.61.667-2.333.025-.045-.025-.121 0-.167.996-1.756 3.09-3.001 5.335-3.001zm170.391 0c2.325 0 4.182 1.343 5.168 3.168h.167c.303.753.5 1.534.5 2.334 0 3.118-2.539 5.668-5.835 5.668-3.272 0-6.002-2.55-6.002-5.668 0-.92.248-1.745.666-2.501.967-1.717 3.015-3.001 5.336-3.001z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M526.084 722.83h14.505v7.836h21.841c.286.833.56 1.629 1 2.334l-20.34 22.507-8.503-3.667-15.505 17.339 5.168 7.336-16.839 18.673c-2.34-.87-5.059-1.176-7.502-.834-2.065-4.745-3.52-9.686-4.502-14.838-.428-2.246-.792-4.521-1-6.836h-8.67a79.993 79.993 0 0 1-.333-7.336v-6.002l8.836.167v5.835c0 2.49-.03 4.916.167 7.336.188 2.309.563 4.582 1 6.835l8.836-2.834s-1.063-15.14-.833-11.337c.189 3.26-.334-11.337-.334-11.337l-8.836-2.168v-12.837c4.038-1.314 7.113-4.478 8.503-8.336h23.341zm83.529 0h14.004v7.836h23.342c1.39 3.859 4.6 7.022 8.67 8.336v12.838l-9.004 2.167s-.36 14.598-.167 11.337c.246-3.803-1 11.337-1 11.337l9.003 2.835c-.987 5.162-2.607 10.084-4.668 14.838-2.454-.343-4.975-.035-7.336.834l-16.84-18.673 5.003-7.336-15.506-17.34-8.503 3.668-19.34-22.174c.507-.807 1.012-1.58 1.334-2.5l21.007-.167v-7.835z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g fill="#dead00">
            <g fill="#9f7e00">
              <path
                d="m664.298 759.412-.02-20.368c5.617-1.66 9.685-6.654 9.685-12.527 0-5.862-4.125-10.907-9.742-12.604l.057-27.866h-8.607l-.035 28.03c-4.222 1.334-7.499 4.451-8.812 8.49l-23.235.034v8.147h23.388c1.39 3.86 4.534 6.89 8.602 8.204l.015 20.51 8.684-.05zm.056-114.1-.077 27.508h-8.607v-27.616c-.66-.2-1.308-.47-1.922-.777l-31.837 35.855-6.583-5.229 32.445-36.555c-.266-.52-.552-1.063-.74-1.64H623.49v-8.147h23.47c1.805-5.28 7.003-9.067 13.167-9.067 7.651 0 13.877 5.877 13.877 13.125 0 5.893-4.018 10.866-9.65 12.543zm-84.907-.108-.076 16.944h-8.603l.02-16.8c-4.283-1.263-7.656-4.432-9.062-8.49H540.73v-8.147h20.996c1.81-5.28 6.982-9.067 13.151-9.067 6.17 0 11.383 3.787 13.192 9.067h21.411v8.147h-21.467a13.349 13.349 0 0 1-8.566 8.346zm39.509 136.631-8.484 3.603-15.533-17.23 5.1-7.34z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
              <path
                d="m548.136 636.878-2.622 8.47h-23.91l-2.586-8.47zm0-8.203-2.622-8.454h-23.91l-2.586 8.454zM530.799 781.835l8.49 3.603 15.527-17.23-5.1-7.34zm-6.583-5.321-5.091-7.37 15.538-17.23 8.464 3.619z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
              <path
                d="m529.935 828.898-4.237 7.299c-7.258-4.508-13.724-10.074-19.28-16.315-4.415 1.298-9.404.526-13.17-2.54-5.828-4.723-6.533-13.013-1.544-18.513l.725-.772c-3.511-7.932-5.888-16.457-6.7-25.397l8.678.035a69.857 69.857 0 0 0 5.551 21.702 15.394 15.394 0 0 1 7.39.813l21.718-24.028 6.542 5.28-21.579 23.992c2.913 4.431 2.796 10.145-.531 14.51 4.789 5.3 10.293 10.023 16.437 13.933z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
              <path
                d="M523.5 824.226c7.488 5.842 16.187 10.585 25.592 13.59l1.978-8.596c-7.728-2.433-14.89-6-21.186-10.631zm-4.298 7.427c7.595 5.714 16.279 10.294 25.586 13.468l-6.65 6.215a98.928 98.928 0 0 1-20.91-10.723zM485.463 759.412l.01-20.368c-5.607-1.66-9.68-6.654-9.68-12.527 0-5.862 4.129-10.907 9.746-12.604l-.066-27.866h8.612l.015 28.03c4.247 1.334 7.519 4.451 8.832 8.49l23.22.034v8.147h-23.368c-1.39 3.86-4.57 6.89-8.607 8.204l-.015 20.51-8.7-.05"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
              <path
                d="m486.792 779.938-8.924-1.998-1.258-22.601 8.853-2.924.01 12.962c0 5.03.444 9.788 1.318 14.561zm7.406-28.024 8.888 2.09s.455 14.526.266 11.266c-.23-3.803.971 11.356.971 11.356l-8.965 2.955c-.894-4.616-1.196-9.338-1.196-14.204l.015-13.463h.02zm-8.623-86.143-8.924 2.505v22.642l8.924 2.448zm8.664 0 8.903 2.505v22.642l-8.903 2.448zm24.988 56.816 2.607-8.454h23.925l2.581 8.454z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
            </g>
            <path
              d="m519.227 730.77 2.607 8.469h23.925l2.581-8.47z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <g fill="#9f7e00">
              <path
                d="M588.274 840.827c6.818-1.078 13.1-2.954 19.305-5.566l4.263 7.263c-7.136 3.062-14.828 5.265-22.842 6.47-1.334 5.93-6.87 10.381-13.53 10.381-6.644 0-12.185-4.395-13.56-10.288-8.464-1.155-16.493-3.338-24.012-6.563l4.283-7.263c6.527 2.755 13.494 4.595 20.721 5.602 1.528-3.312 4.324-5.873 8-7.064l.076-35.563h8.581l.077 35.436c3.808 1.14 7.023 3.73 8.622 7.155h.015z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
              <path
                d="M626.25 824.226c-7.498 5.842-16.202 10.585-25.581 13.59l-1.978-8.596c7.707-2.433 14.883-6 21.165-10.631zm4.304 7.427c-7.621 5.714-16.274 10.294-25.587 13.468l6.645 6.215a98.882 98.882 0 0 0 20.92-10.723zM579.6 805.249l8.924-2.505v-22.622l-8.924-2.453zm-8.658 0-8.909-2.505v-22.622l8.909-2.453zM602.074 636.878l2.632 8.47h23.9l2.592-8.47zm0-8.203 2.632-8.454h23.9l2.592 8.454z"
                transform="matrix(.2037 0 0 .22204 157.315 148.89)"
              />
            </g>
          </g>
          <path
            fill="#9f7e00"
            d="m519.249 730.833 2.667 8.336h23.842l2.5-8.336z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#dead00"
            d="m601.943 730.833 2.501 8.336h23.842l2.667-8.336z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g fill="#b50027">
            <path
              d="M569.933 738.502a4.9 4.9 0 0 0 1 .333v38.847l-8.836 2.5v22.508l8.836 2.501v28.677c-3.675 1.19-6.475 3.69-8.003 7.002-4.713-.657-9.396-1.613-13.838-3.001l2-8.67c-7.727-2.432-14.876-6.04-21.173-10.67l-6.502 5.669a84.36 84.36 0 0 0 5.835 4.168c-2.032-1.325-3.948-2.674-5.835-4.168-3.554-2.815-6.83-5.841-9.837-9.17 3.328-4.365 3.414-10.074.5-14.505l16.673-18.673 8.502 3.668 15.506-17.34-5.002-7.335zm10.837.167 24.341 27.676 6.502-5.169 9.003 10.004-6.502 5.335-9.003-10.17-5.002-5.502-5.168 7.336 15.505 17.339 8.503-3.668 16.84 18.673c-2.894 4.431-2.813 10.14.5 14.505-3.016 3.345-6.432 6.344-10.004 9.17a77.88 77.88 0 0 1-5.835 4.168 84.602 84.602 0 0 0 5.835-4.168l-6.502-5.669c-6.282 4.63-13.466 8.237-21.174 10.67l2 8.67c-3.977 1.294-8.05 2.323-12.337 3.001-1.6-3.424-4.862-6.03-8.67-7.17v-28.509l9.004-2.5v-22.508l-9.003-2.501v-38.513c.475-.128.722-.357 1.167-.5zm83.528 20.673v6.002c0 2.515-.113 4.921-.334 7.336h-8.67c.198-2.42.334-4.846.334-7.336v-5.835l8.67-.166z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="m538.088 761.176 6.67 5.169-9.17 10.17-6.503-5.335zm32.845 23.842h8.67v13.17h-8.67zm-41.014 43.848c3.832 2.444 8.082 4.527 12.338 6.335l-4.335 7.336a92.757 92.757 0 0 1-12.171-6.335z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
          </g>
          <path
            fill="#9f7e00"
            d="M563.383 733.075c-.435-.721-.762-1.493-1.048-2.326h-21.718v-8.147h21.57c.245-.685.587-1.37.945-2.019l-26.624-29.614 6.542-5.3 26.292 29.113c.455-.22.915-.414 1.406-.578l.02-38.788h8.582v38.553c.383.108.97.215 1.354.343l25.658-29.185 6.599 5.25-25.766 29.02c.665.971 1.12 2.055 1.482 3.205h20.9v8.147l-21.017.057c-.302.92-.833 1.768-1.33 2.576l24.402 27.743-6.548 5.3-24.283-27.779c-.444.164-.67.343-1.165.47l-.056 45.872h-8.602l-.025-46.071c-.358-.108-.66-.292-1.002-.45l-25.28 27.958-6.542-5.3 25.254-28.05"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M497.24 803.599c2.136-2.382 5.882-2.653 8.377-.634 2.494 2.02 2.8 5.587.67 7.933-2.142 2.361-5.884 2.647-8.378.628-2.494-2.034-2.796-5.566-.67-7.927zm-13.51-77.082c0-3.123 2.658-5.643 5.934-5.643s5.924 2.52 5.924 5.643c0 3.118-2.648 5.602-5.924 5.602s-5.934-2.484-5.934-5.602z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="m619.815 828.898 4.247 7.299c7.248-4.508 13.724-10.074 19.28-16.315 4.395 1.298 9.404.526 13.166-2.54 5.827-4.723 6.496-13.013 1.539-18.513l-.736-.772c3.521-7.932 5.903-16.457 6.68-25.397l-8.638.035c-.685 7.626-2.607 14.889-5.56 21.702a15.455 15.455 0 0 0-7.402.813l-21.697-24.028-6.547 5.28 21.564 23.992c-2.893 4.431-2.78 10.145.531 14.51-4.779 5.3-10.278 10.023-16.427 13.933z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M652 803.7c-2.131-2.382-5.862-2.653-8.352-.634-2.499 2.02-2.8 5.587-.67 7.933 2.132 2.361 5.884 2.647 8.378.628 2.494-2.034 2.775-5.566.644-7.927z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="m662.948 779.938 8.924-1.998 1.258-22.601-8.832-2.924-.02 12.962c0 5.03-.44 9.788-1.33 14.561zm-7.385-28.024-8.889 2.09s-.48 14.526-.286 11.266c.246-3.803-.97 11.356-.97 11.356l8.964 2.955c.895-4.616 1.196-9.338 1.196-14.204l-.015-13.463m.03-86.143-8.903 2.505v22.642l8.903 2.448zm8.664 0 8.929 2.505v22.642l-8.93 2.448zM625.54 776.514l5.09-7.37-15.533-17.23-8.469 3.619z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="none"
            d="M484.15 632.784c0-3.097 2.662-5.622 5.938-5.622 3.272 0 5.92 2.525 5.92 5.622 0 3.103-2.648 5.607-5.92 5.607-3.276 0-5.939-2.504-5.939-5.607z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M654.131 726.517c0-3.123 2.668-5.643 5.94-5.643 3.296 0 5.918 2.52 5.918 5.643 0 3.118-2.622 5.602-5.918 5.602-3.272 0-5.94-2.484-5.94-5.602z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#9f7e00"
            d="m630.983 722.587-2.622-8.454h-23.91l-2.581 8.454zm0 8.183-2.622 8.469h-23.91l-2.581-8.47z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M569.531 846.235c0-3.118 2.663-5.638 5.94-5.638 3.27 0 5.913 2.52 5.913 5.638 0 3.102-2.642 5.607-5.913 5.607-3.277 0-5.94-2.505-5.94-5.607zm84.662-213.451c0-3.097 2.642-5.622 5.934-5.622 3.276 0 5.924 2.525 5.924 5.622 0 3.103-2.648 5.607-5.924 5.607-3.292 0-5.934-2.504-5.934-5.607zm-85.249 0c0-3.097 2.662-5.622 5.934-5.622 3.276 0 5.923 2.525 5.923 5.622 0 3.103-2.647 5.607-5.923 5.607-3.272 0-5.934-2.504-5.934-5.607z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <g fill="#9f7e00">
            <path
              d="m495.476 645.133 32.006 35.813 6.552-5.3-32.185-35.67c.644-.956 1.1-1.999 1.482-3.118h23.415v-8.147h-23.43c-1.794-5.28-7.043-9.067-13.228-9.067-7.651 0-13.876 5.877-13.876 13.125 0 5.75 3.894 10.651 9.338 12.415l-.051 27.636h8.602v-27.452c.363-.108 1.027-.108 1.375-.235z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
            <path
              d="m529.173 670.239 8.495-3.604 15.533 17.235-5.1 7.35zm-6.578 5.336-5.08 7.375 15.528 17.214 8.469-3.624z"
              transform="matrix(.2037 0 0 .22204 157.315 148.89)"
            />
          </g>
          <path
            fill="#9f7e00"
            d="m570.845 655.12-8.909 2.504v22.637l8.909 2.454zm8.566 0 8.904 2.504v22.637l-8.904 2.454z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#006f46"
            d="M561.415 726.839c0-7.283 6.225-13.177 13.897-13.177 7.652 0 13.872 5.894 13.872 13.177 0 7.247-6.22 13.12-13.872 13.12-7.672 0-13.897-5.873-13.897-13.12"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <path
          fill="#c8b100"
          d="M470.303 603.01h20.694v-4.934h-20.694z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#dead00"
          d="M470.303 603.01h20.694v-4.934h-20.694z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g strokeWidth={2.467}>
          <path
            fill="#f6cb7e"
            d="M467.468 833.44c9.953 2.994 14.997 10.409 14.997 19.088 0 11.305-10.964 19.884-25.2 19.884-14.232 0-25.776-8.58-25.776-19.884 0-8.545 4.747-18.092 14.643-18.781 0 0-.301-.896-1.154-2.367-1.025-1.097-3.051-3.142-3.051-3.142s3.78-.709 5.959.12c2.193.828 3.635 2.213 3.635 2.213s1.035-2.027 2.482-3.598c1.46-1.557 3.353-2.534 3.353-2.534s2.189 1.84 2.907 3.07c.714 1.27 1.179 2.774 1.179 2.774s2.011-1.657 3.76-2.333c1.743-.69 3.995-1.23 3.995-1.23s-.642 2.179-1.068 3.29a30.9 30.9 0 0 0-.81 2.444l-.425.769z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#006f46"
            d="M455.162 884.68s-18.926-12.757-27.131-14.481c-10.49-2.213-22.28-.422-27.38-.69.143.149 6.116 4.407 8.737 7.041 2.625 2.62 11.366 7.856 16.305 9.092 15.357 3.851 29.469-.963 29.469-.963m5.403 1.111s12.124-12.602 24.813-14.341c14.998-2.079 24.812 1.236 30.637 2.754.134 0-4.814 2.347-7.43 4.139-2.629 1.791-9.383 7.448-19.71 7.568-10.347.154-21.762-1.082-23.654-.795a330.84 330.84 0 0 0-4.656.675"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#b50027"
            d="M454.595 867.62c-4.766-4.425-5.397-8.132-5.397-15.106 0-6.96 2.984-13.245 7.746-17.651a24.003 24.003 0 0 1 7.688 17.651c0 6.974-.226 10.454-4.968 14.88l-2.629 1.831z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            fill="#006f46"
            d="M451.913 894.987s3.124-6.17 3.407-12.387c.249-5.202-.733-10.337-.733-10.337h3.784s1.892 5.523 1.892 10.337c0 4.829-.876 11.252-.876 11.252s-2.62.403-3.492.81c-.858.421-3.12 1.507-3.12 1.507l-1.375.36z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <path fill="#b2b2b2" d="M249.993 282.922h48.766v-58.85h-48.766z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.465}
        d="M454.965 603.652H694.36V338.604H454.965z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <g stroke="#000">
        <path
          fill="#b50027"
          d="M604.393 568.991s-2.96 3.056-1.892 5.605c1.087 2.553 2.96 5.22 2.96 5.22s-.105-3.798 1.092-4.828c1.73-1.523 4.958-1.791 4.958-1.791s-2.553-2.28-3.372-2.534c-.786-.273-3.746-1.672-3.746-1.672zm14.787 4.474s-1.48 3.684 1.356 6.098c2.816 2.433 5.245 2.687 5.245 2.687s-2.16-3.837-1.48-5.863c.694-2.112 2.548-3.43 2.548-3.43s-3.497-1.164-4.033-1.03c-.532.12-3.636 1.538-3.636 1.538zm-41.604-165.463.268-2.94.407-1.639s-7.664.627-11.698-.508c-4.033-1.145-7.668-2.802-11.438-5.978-3.756-3.195-5.24-5.187-7.933-5.59-6.457-1.03-11.434 1.892-11.434 1.892s4.853 1.787 8.493 6.232c3.617 4.479 7.564 6.74 9.274 7.281 2.821.862 12.631.254 15.323.355 2.692.134 8.737.91 8.737.91v-.015z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#fff"
          d="m564.006 412.208 1.6-2.534 1.585 2.3-3.185.234m3.884-.12 1.888-2.534 2.021 2.28-3.909.254m-1.743-15.658 3.904 1.403-3.497 1.772-.407-3.175m4.703 1.283 3.497.882-2.816 2.16z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#d85aac"
          strokeLinejoin="round"
          strokeWidth={1.203}
          d="M613.415 397.225s.02 3.43.355 6.706c.32 3.142-1.016 5.896-.498 7.635.498 1.758.747 3.142 1.427 4.407.642 1.27.997 4.479.997 4.479s-1.835-1.303-3.535-2.568a55.675 55.675 0 0 0-2.874-2.079s.345 3.43.502 4.9c.182 1.471 1.04 4.24 2.43 5.878 1.374 1.605 4.123 4.24 4.971 6.352.882 2.131.704 6.825.704 6.825s-2.232-3.563-4.148-4.205c-1.882-.661-6.021-2.956-6.021-2.956s3.794 3.765 3.794 7.348c0 3.578-1.547 7.65-1.547 7.65s-1.715-3.243-3.943-5.37c-2.246-2.112-5.35-4.239-5.35-4.239s2.424 5.537 2.424 9.274c0 3.765-.676 11.754-.676 11.754s-1.892-3.09-3.784-4.593c-1.907-1.452-4.134-2.755-4.833-3.717-.676-.978 2.251 3.075 2.567 5.523.336 2.452 1.5 11.184 9.135 22.336 4.46 6.519 11.362 17.92 26.15 14.169 14.805-3.732 9.311-23.63 6.207-32.923-3.104-9.273-4.656-19.562-4.474-23.16.158-3.563 2.745-14.154 2.405-16.132-.34-1.94-1.145-9.509.694-15.606 1.892-6.352 3.464-8.819 4.48-11.439 1.01-2.6 1.867-4.071 2.212-6.352.34-2.28.34-6.538.34-6.538s2.745 5.068 3.44 6.86c.68 1.805.68 7.16.68 7.16s.512-5.355 4.656-7.956c4.138-2.634 8.952-5.389 10.16-6.86 1.202-1.484 1.556-2.447 1.556-2.447s-.354 9.14-2.927 12.737c-1.71 2.333-8.45 9.934-8.45 9.934s3.46-1.317 5.864-1.45c2.41-.188 4.124 0 4.124 0s-2.927 2.28-6.71 7.816c-3.78 5.528-2.243 6.017-4.992 10.577-2.769 4.56-4.996 4.728-8.44 7.501-5.174 4.153-2.386 20.674-1.71 23.126.694 2.434 9.632 22.667 9.81 27.553.158 4.895 1.034 15.812-7.583 22.82-5.547 4.545-14.624 4.579-16.694 5.877-2.074 1.284-6.174 5.355-6.174 13.839 0 8.497 3.07 9.78 5.48 11.908 2.424 2.126 5.513.982 6.203 2.62.7 1.619 1.035 2.6 2.074 3.578 1.035.963 1.73 2.112 1.375 3.885-.34 1.81-4.302 5.882-5.676 8.837-1.39 2.903-4.139 10.591-4.139 11.722 0 1.15-.321 4.732.857 6.538 0 0 4.302 5.02 1.37 5.997-1.887.642-3.74-1.183-4.632-.977-2.572.675-3.913 2.26-4.656 2.127-1.714-.321-1.714-1.164-1.892-3.583-.158-2.434-.072-3.43-.838-3.43-1.035 0-1.557.848-1.73 2.132-.186 1.298-.186 4.22-1.374 4.22-1.212 0-2.927-2.113-3.961-2.582-1.035-.494-3.957-.982-4.125-2.28-.172-1.303 1.72-4.072 3.607-4.565 1.892-.489 3.622-1.451 2.41-2.429-1.212-.982-2.41-.982-3.602 0-1.212.978-3.785.149-3.622-1.317.177-1.47.518-3.248.336-4.071-.158-.796-2.228-2.434.503-3.924 2.764-1.45 3.956 1.323 6.706.83 2.764-.47 4.139-1.486 5.173-3.09 1.035-1.624.853-5.054-1.034-7.162-1.893-2.131-3.78-2.466-4.48-3.77-.694-1.297-1.71-4.392-1.71-4.392s.499 5.696.159 6.524c-.336.81-.158 4.22-.158 4.22s-1.892-2.112-3.444-3.731c-1.533-1.638-3.085-6.52-3.085-6.52s-.163 4.56-.163 6.367c0 1.772 2.05 3.41 1.375 4.071-.695.642-3.957-3.43-4.814-4.071-.877-.657-3.622-2.77-4.834-5.068-1.197-2.28-2.074-5.523-2.41-6.687-.344-1.136-.91-6.218-.344-7.501.857-1.945 2.237-5.375 2.237-5.375h-6.711c-3.602 0-6.189-1.13-7.564 1.303-1.37 2.448-.694 7.348 1.02 13.7 1.73 6.332 2.745 9.44 2.247 10.59-.503 1.13-2.745 3.751-3.602 4.225-.877.508-3.286.336-4.32-.134-1.016-.493-2.726-1.322-6.012-1.322-3.262 0-5.332.154-6.524-.134-1.212-.335-4.139-1.806-5.533-1.485-1.375.336-3.75 1.552-3.104 3.43 1.054 2.936-1.015 3.597-2.404 3.43-1.375-.173-2.554-.661-4.302-1.136-1.71-.503-4.301 0-3.957-1.973.336-1.96 1.035-2.113 1.888-3.564.871-1.49 1.192-2.433.225-2.534-1.207-.12-2.42-.254-3.363.522-.91.762-2.39 2.4-3.607 1.792-1.217-.642-2.155-2.046-2.155-5.12 0-3.057-3.234-5.725-.269-5.59 2.96.133 6.725 2.298 7.4.641.662-1.672.255-2.414-1.35-3.717-1.614-1.265-3.626-2.026-1.47-3.684 2.145-1.638 2.682-1.638 3.5-2.548.806-.881 1.96-3.75 3.464-3.042 2.956 1.404.14 3.444 3.1 6.74 2.964 3.31 4.837 4.479 9.814 3.952 4.972-.503 6.333-1.145 6.333-2.549 0-1.403-.417-3.937-.56-4.967-.12-1.015.684-4.713.684-4.713s-2.285 1.418-2.96 2.802c-.647 1.403-2.002 3.803-2.002 3.803s-.551-2.855-.393-5.187c.09-1.366.575-3.751.522-4.22-.13-1.27-1.073-4.46-1.073-4.46s-.81 3.444-1.336 4.46c-.537 1.01-.805 5.101-.805 5.101s-3.157-2.754-2.28-7.381c.656-3.57-.542-8.278.531-9.815 1.054-1.538 3.603-7.775 9.796-8.043 6.189-.234 11.022.269 13.183.154 2.15-.154 9.81-1.538 9.81-1.538s-14.117-7.247-17.34-9.427c-3.23-2.146-8.206-7.755-9.83-10.303-1.61-2.553-3.085-7.501-3.085-7.501s-2.534.115-4.833 1.384c-2.285 1.25-4.565 3.195-5.906 4.694-1.36 1.538-3.497 4.987-3.497 4.987s.393-4.46.393-5.863c0-1.37-.268-4.086-.268-4.086s-1.605 6.112-4.834 8.392c-3.228 2.313-6.993 5.49-6.993 5.49s.412-3.411.412-4.187c0-.762.805-4.714.805-4.714s-2.285 3.41-5.782 4.086c-3.497.628-8.617.494-9.025 2.673-.393 2.141.944 5.082.144 6.6-.81 1.538-2.553 2.554-2.553 2.554s-2.012-1.672-3.765-1.792c-1.749-.134-3.368.776-3.368.776s-1.48-1.925-.948-3.19c.55-1.27 3.228-3.176 2.567-3.952-.675-.761-2.83.268-4.172.896-1.336.642-4.172 1.265-3.904-.896.269-2.165.944-3.43.269-4.967-.67-1.504-.269-2.534.819-2.922 1.068-.354 5.37.115 5.777-.862.393-1.03-1.068-2.3-3.904-2.941-2.822-.623-4.172-2.294-2.692-3.698s1.887-1.772 2.558-3.056.934-3.569 3.501-2.419c2.534 1.135 1.998 3.937 4.714 4.833 2.658.91 8.99-.373 10.322-1.13 1.36-.781 5.658-3.957 7.138-4.733 1.485-.742 7.654-5.336 7.654-5.336s-3.621-2.52-4.977-3.818c-1.336-1.269-3.746-4.31-4.938-4.953-1.217-.656-7.138-2.922-9.154-3.056-2.017-.134-8.206-2.28-8.206-2.28s2.822-.91 3.765-1.671 3.066-2.688 4.173-2.554c1.053.14 1.317.14 1.317.14s-5.758-.274-6.975-.628c-1.207-.407-4.703-2.568-6.04-2.568-1.36 0-4.033.523-4.033.523s3.621-2.295 6.581-2.803c2.96-.488 5.246-.388 5.246-.388s-4.565-1.269-5.657-2.787c-1.069-1.538-2.137-3.804-2.96-4.834-.8-1.01-1.337-2.682-2.817-2.802-1.48-.134-4.038 1.792-5.514 1.653-1.46-.115-2.553-1.03-2.697-3.176-.1-2.175 0-1.418-.512-2.548-.537-1.164-2.692-3.837-.68-4.46 2.035-.642 6.332.374 6.725-.388.412-.762-2.28-3.056-4.028-3.952-1.749-.881-4.57-2.419-3.09-3.683 1.485-1.27 2.955-1.773 3.765-2.922.805-1.15 1.748-4.326 3.497-3.315 1.748 1.016 4.167 5.997 5.513 5.61 1.356-.389 1.456-3.953 1.212-5.471-.268-1.538 0-4.206 1.322-3.957 1.356.254 2.424 2.031 4.584 2.18 2.137.12 5.365-.503 5.097.996-.269 1.523-1.485 3.416-2.96 5.087-1.442 1.672-2.122 4.968-1.193 7.128.939 2.18 3.372 5.628 5.513 7.013 2.137 1.398 6.17 2.433 8.737 4.071 2.549 1.672 8.474 6.366 10.49 6.874 2.013.522 4.03 1.537 4.03 1.537s2.28-1.015 5.388-1.015c3.085 0 10.203.508 12.895-.642 2.692-1.164 6.189-3.056 5.116-5.49-1.064-2.4-6.989-4.579-6.452-6.47.536-1.907 2.692-2.041 6.308-2.175 3.626-.12 8.603.641 9.532-4.46.944-5.087 1.212-8.028-3.87-9.159-5.12-1.15-8.89-1.264-9.81-4.967-.953-3.683-1.892-4.574-.824-5.609 1.092-.996 2.96-1.518 6.725-1.753 3.765-.273 8.062-.273 9.279-1.183 1.212-.862 1.46-3.296 2.94-4.326 1.476-.996 7.277-1.91 7.277-1.91s6.907 3.38 13.326 8.142c5.743 4.292 10.936 10.63 10.936 10.63"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          d="M563.862 393.642s-.805-2.295-.944-2.937c-.124-.627-.229-1.372-.229-1.372s3.865-.031 3.726 1.233c-.13 1.284-1.341 1.284-1.61 1.778-.263.522-.943 1.298-.943 1.298"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          strokeWidth={0.75}
          d="m582.965 387.003-.283-2.04s3.636.033 5.384 1.264c2.697 1.91 4.426 4.847 4.302 4.967-.47.455-2.553-1.27-4.033-1.772 0 0-1.073.254-2.156.254-1.073 0-1.61-.508-1.753-1.016-.12-.522.143-1.403.143-1.403l-1.604-.235v-.02z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          strokeLinecap="round"
          d="M609.186 415.79s-1.624-2.298-2.017-3.074c-.412-.743-1.087-2.28-1.087-2.28"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M510.74 392.866s2.284 1.638 4.033 1.892c1.748.268 3.64.268 3.909.268.263 0 .819-2.567.531-4.32-.943-5.744-6.189-7.013-6.189-7.013s1.567 3.482.805 5.087c-1.073 2.294-3.09 4.086-3.09 4.086"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M510.74 392.866s2.284 1.638 4.033 1.892c1.748.268 3.64.268 3.909.268.263 0 .819-2.567.531-4.32-.943-5.744-6.189-7.013-6.189-7.013s1.567 3.482.805 5.087c-1.073 2.294-3.09 4.086-3.09 4.086z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M499.842 397.833s-2.017-3.698-6.313-3.195c-4.302.508-7.138 3.837-7.138 3.837s4.747-.153 5.921.623c1.753 1.15 2.285 4.09 2.285 4.09s2.572-1.537 3.372-2.553c.8-1.03 1.873-2.802 1.873-2.802"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M499.842 397.833s-2.017-3.698-6.313-3.195c-4.302.508-7.138 3.837-7.138 3.837s4.747-.153 5.921.623c1.753 1.15 2.285 4.09 2.285 4.09s2.572-1.537 3.372-2.553c.8-1.03 1.873-2.802 1.873-2.802z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M494.597 412.716s-3.621.522-5.633 2.821c-2.036 2.294-1.749 6.62-1.749 6.62s2.405-2.534 4.565-2.534 5.514.762 5.514.762-1.073-2.702-1.073-3.837c0-1.145-1.624-3.832-1.624-3.832"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M494.597 412.716s-3.621.522-5.633 2.821c-2.036 2.294-1.749 6.62-1.749 6.62s2.405-2.534 4.565-2.534 5.514.762 5.514.762-1.073-2.702-1.073-3.837c0-1.145-1.624-3.832-1.624-3.832z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          strokeLinejoin="round"
          d="M544.625 427.632s-3.828 1.116-5.24 3.176c-1.744 2.548-1.62 5.101-1.62 5.101s3.229-2.668 7.401-1.537c4.177 1.15 4.565 1.537 6.333 1.417 1.748-.134 6.05-1.671 6.05-1.671s-3.497 4.071-3.105 6.893c.407 2.787.925 4.052.815 5.475-.288 3.444-2.831 7.65-2.831 7.65s1.48-.91 4.977-1.672c3.477-.762 6.457-2.434 8.33-3.818 1.873-1.418 4.296-4.848 4.296-4.848s-.78 4.714 0 6.754c.805 2.046 1.073 7.909 1.073 7.909s2.247-1.993 4.029-2.941c.944-.523 3.372-1.792 4.32-3.31.657-1.083 1.48-5.068 1.48-5.068s.532 4.292 1.869 6.37c1.36 2.008 3.353 8.278 3.353 8.278s1.36-4.072 2.84-5.743c1.461-1.658 3.229-3.818 3.354-5.102.124-1.27-.393-4.057-.393-4.057l1.873 4.057m-54.315 2.922s2.285-3.937 4.44-5.221c2.16-1.284 5.121-3.564 5.921-3.818.786-.254 4.301-2.18 4.301-2.18m4.71 24.598s5.172-2.654 6.72-3.583c3.233-1.892 5.513-5.336 5.513-5.336"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M506.83 460.86s-2.011-2.145-5.508-1.523c-3.497.642-5.781 4.599-5.781 4.599s2.96-.781 4.713-.393c1.744.393 2.96 2.165 2.96 2.165s1.605-1.404 2.141-2.165c.537-.757 1.461-2.683 1.461-2.683"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M506.83 460.86s-2.011-2.145-5.508-1.523c-3.497.642-5.781 4.599-5.781 4.599s2.96-.781 4.713-.393c1.744.393 2.96 2.165 2.96 2.165s1.605-1.404 2.141-2.165c.537-.757 1.461-2.683 1.461-2.683h.015z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M502.802 474.996s-2.96-.503-5.508 1.538c-2.553 2.045-2.697 5.982-2.697 5.982s2.429-2.045 4.32-1.772c1.874.235 4.154 1.265 4.154 1.265s.412-2.434.531-3.056c.417-1.778-.8-3.957-.8-3.957"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M502.802 474.996s-2.96-.503-5.508 1.538c-2.553 2.045-2.697 5.982-2.697 5.982s2.429-2.045 4.32-1.772c1.874.235 4.154 1.265 4.154 1.265s.412-2.434.531-3.056c.417-1.778-.8-3.957-.8-3.957z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M509.671 488.006s-.196 3.784 1.605 6.097c1.892 2.434 5.389 2.807 5.389 2.807s-1.178-2.533-1.356-3.822c-.268-1.906 1.605-3.564 1.605-3.564s-1.73-1.772-3.478-1.772c-1.753 0-3.765.254-3.765.254"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M509.671 488.006s-.196 3.784 1.605 6.097c1.892 2.434 5.389 2.807 5.389 2.807s-1.178-2.533-1.356-3.822c-.268-1.906 1.605-3.564 1.605-3.564s-1.73-1.772-3.478-1.772c-1.753 0-3.765.254-3.765.254z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="none"
          d="M589.015 494.357s9.685 5.997 9.417 10.965c-.288 4.967-5.389 11.467-5.389 11.467"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M544.625 521.503s-2.42-3.056-5.772-2.937c-3.373.134-6.874 3.291-6.874 3.291s4.182-.354 5.245 1.03c1.092 1.423 2.16 3.176 2.16 3.176s1.878-.997 2.697-1.639c.805-.622 2.544-2.921 2.544-2.921"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M544.625 521.503s-2.42-3.056-5.772-2.937c-3.373.134-6.874 3.291-6.874 3.291s4.182-.354 5.245 1.03c1.092 1.423 2.16 3.176 2.16 3.176s1.878-.997 2.697-1.639c.805-.622 2.544-2.921 2.544-2.921z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M534.269 534.867s-4.422-.642-6.582 1.652c-2.16 2.285-2.017 6.49-2.017 6.49s2.697-2.921 5.102-2.672c2.428.254 5.12 1.538 5.12 1.538s-.412-2.549-.68-3.698c-.268-1.15-.943-3.31-.943-3.31"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#b50027"
          d="M534.269 534.867s-4.422-.642-6.582 1.652c-2.16 2.285-2.017 6.49-2.017 6.49s2.697-2.921 5.102-2.672c2.428.254 5.12 1.538 5.12 1.538s-.412-2.549-.68-3.698c-.268-1.15-.943-3.31-.943-3.31z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <path
          fill="#db4446"
          d="M543.83 549.007s-2.16 3.056-.537 5.47c1.605 2.434 4.963 3.583 4.963 3.583s-1.198-1.772-.661-3.837c.426-1.619 3.228-3.817 3.228-3.817l-6.993-1.385"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#b50027">
          <path
            d="M543.83 549.007s-2.16 3.056-.537 5.47c1.605 2.434 4.963 3.583 4.963 3.583s-1.198-1.772-.661-3.837c.426-1.619 3.228-3.817 3.228-3.817l-6.993-1.385v-.015zm59.023 5.743s-3.885-.915-6.045.37c-2.141 1.269-3.89 6.624-3.89 6.624s3.497-2.922 6.05-2.568c2.549.403 4.44 1.418 4.44 1.418s.389-2.18.12-3.683c-.157-.91-.675-2.16-.675-2.16"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M602.853 554.75s-3.885-.915-6.045.37c-2.141 1.269-3.89 6.624-3.89 6.624s3.497-2.922 6.05-2.568c2.549.403 4.44 1.418 4.44 1.418s.389-2.18.12-3.683c-.157-.91-.675-2.16-.675-2.16z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
        <g fill="#9f7e00" transform="matrix(.2037 0 0 .22204 156.432 148.714)">
          <g strokeWidth={0.75}>
            <path d="m614.988 377.612-1.375.101c-.063.168-.68 1.15-1.265 1.69-1.216 1.165-3.05 1.299-4.086.322a2.34 2.34 0 0 1-.66-1.945c-.805.407-1.644.407-2.43-.033-1.23-.71-1.537-2.4-.641-3.804.143-.268.287-.622.503-.824l-.091-1.537-1.662.388-.48.91c-1.034 1.169-2.567 1.47-3.333.78-.374-.32-.453-.592-.623-1.25-.373.318-.397.403-.824.503-2.548.628-3.564-4.981-3.621-6.433l-.838 1.184s.752 3.357.373 6.198c-.373 2.836-1.375 5.676-1.375 5.676 3.555.91 8.872 3.799 14.146 7.87 5.283 4.038 9.436 8.43 11.15 11.506 0 0 2.731-1.523 5.6-2.433 2.841-.93 6.458-.949 6.458-.949l1.03-1.01c-1.514.22-7.521.474-7.401-2.046.006-.382-.073-.43.486-.98-.951 0-1.104.084-1.535-.184-.872-.575-.853-2.045.11-3.262l.838-.608.053-1.62-1.61.221c-.143.201-.512.436-.728.642-1.265 1.097-3.085 1.178-4.086.148-.604-.589-.79-1.384-.532-2.213-.733.22-1.499.154-2.146-.22-1.226-.742-1.46-2.481-.512-3.832.44-.661 1.317-1.437 1.47-1.518l-.33-1.423" />
            <path d="m608.794 384.687-1.552-1.197c-.282-.22-.373-.575-.191-.776.177-.187.55-.187.838.014l1.547 1.217 1.59 1.202c.269.202.37.556.197.776-.197.187-.57.168-.857-.033l-1.572-1.202m-8.292-5.677-1.23-.723c-.307-.187-.465-.541-.322-.776.125-.254.498-.288.8-.106l1.227.729 1.255.728c.302.167.445.522.32.776-.143.22-.497.268-.819.086l-1.23-.714" />
          </g>
          <ellipse
            cx={723.167}
            cy={-29.36}
            fillRule="evenodd"
            strokeWidth={0.751}
            rx={0.958}
            ry={0.713}
            transform="matrix(.82291 .56817 -.612 .79086 0 0)"
          />
          <path
            strokeWidth={0.75}
            d="m616.52 391.293 1.016.982c.25.235.642.32.857.134.216-.168.187-.508-.052-.743l-1.001-.996-1.035-1.015c-.249-.235-.642-.302-.857-.115-.23.148-.197.522.072.757l1 .996"
          />
          <ellipse
            cx={670.97}
            cy={-266.317}
            fillRule="evenodd"
            strokeWidth={0.751}
            rx={0.958}
            ry={0.713}
            transform="matrix(.59251 .80556 -.83654 .54791 0 0)"
          />
          <g strokeWidth={0.75}>
            <path d="m607.951 366.428-2.812.086-.55 4.139.3.656.734-.048 3.602-2.42c-.4-.818-.831-1.619-1.274-2.413z" />
            <path d="m600.325 368.727-.076 2.582 4.373.541.68-.287-.057-.71-2.549-3.395c-.844.342-1.62.769-2.37 1.269z" />
            <path d="m609.364 373.876-2.333 1.303-2.553-3.41-.052-.695.68-.287 4.388.522c.055.874.036 1.714-.13 2.567z" />
            <circle cx={604.752} cy={371.144} r={1.47} fillRule="evenodd" />
            <path d="M593.475 366.413c-.072.015-.613-2.18-1.216-3.396-.407-.881-1.854-2.026-1.854-2.026.143-.273 1.964-.93 4.139.436 1.762 1.456-.144 4.124-.144 4.124s-.464.642-.91.862" />
            <path d="m598.39 367.898-1.993 1.725-3.247-2.822.282-.407.115-.694 4.402-.321c.187.834.326 1.674.441 2.52z" />
            <path d="M592.84 366.428c.024-.751.491-1.34 1.013-1.344.53.024.93.626.915 1.36-.025.75-.498 1.321-1.013 1.343-.554-.021-.944-.622-.916-1.359m25.89 6.739-2.802-.301-1.174 4.038.216.69.732.018 3.923-1.91a380.97 380.97 0 0 0-.895-2.535z" />
            <path d="m610.825 374.417-.44 2.554 4.244 1.11.713-.2.053-.69-2.017-3.736c-.868.277-1.71.62-2.553.962z" />
            <path d="m619.035 380.702-2.514.996-2.017-3.717.052-.709.714-.186 4.244 1.116c-.115.843-.28 1.679-.479 2.5z" />
            <circle cx={614.868} cy={377.574} r={1.47} fillRule="evenodd" />
            <path d="m628.132 381.904.512 2.65-4.153 1.384-.733-.149-.086-.694 1.73-3.837c.914.199 1.821.424 2.73.646z" />
            <path d="m627.384 389.487-2.658.59-1.47-3.953.167-.675.733-.1 4.047 1.657c-.27.828-.543 1.655-.819 2.481z" />
            <path d="m620.175 382.153-.857 2.453 4.052 1.638.743-.1.143-.676-1.441-3.937c-.88.205-1.76.414-2.64.622z" />
            <circle cx={623.733} cy={385.607} r={1.47} fillRule="evenodd" />
            <path d="M631.197 395.33c-.015.068 2.376.12 3.751.422.977.206 2.496 1.303 2.496 1.303.268-.2.536-2.012-1.337-3.75-1.873-1.337-4.215 1.015-4.215 1.015s-.565.556-.695 1.01" />
            <path d="m628.63 391.072-1.37 2.213 3.602 2.434.44-.388.59-.201-.551-4.158c-.904.036-1.807.07-2.711.1z" />
            <path d="M631.308 395.936c.745-.135 1.267-.67 1.149-1.156-.13-.51-.833-.806-1.58-.666-.75.153-1.262.657-1.137 1.18.113.485.822.782 1.568.642" />
          </g>
        </g>
      </g>
      <path
        fill="#fff"
        d="M276.628 235.006s.057.094.044.142c-.01.04-.088.082-.088.082.174.066.265.019.334-.028-.013-.119-.1-.152-.174-.189-.035-.017-.116-.007-.116-.007z"
      />
      <g
        fill="#9f7e00"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.751}
        transform="matrix(.17278 .11762 -.11713 .18166 156.432 148.714)"
      >
        <ellipse cx={705.1} cy={3.237} rx={0.958} ry={0.713} />
        <ellipse cx={715.312} cy={3.039} rx={0.958} ry={0.713} />
      </g>
      <path
        fill="#ce1126"
        d="M234.387 282.667c0-10.67 7.052-19.32 15.751-19.32 8.702 0 15.755 8.65 15.755 19.32s-7.053 19.32-15.754 19.32c-8.7 0-15.752-8.65-15.752-19.32"
      />
      <path
        fill="#b50027"
        stroke="#000"
        strokeWidth={2.882}
        d="M378.352 602.502c0-48.059 34.623-87.016 77.327-87.016 42.718 0 77.341 38.957 77.341 87.016s-34.623 87.016-77.34 87.016c-42.705 0-77.328-38.957-77.328-87.016z"
        transform="matrix(.2037 0 0 .22204 157.315 148.89)"
      />
      <path
        fill="#005bbf"
        fillOpacity={0.941}
        d="M239.06 282.63c0-7.825 4.96-14.167 11.085-14.167 6.122 0 11.083 6.342 11.083 14.167 0 7.828-4.96 14.174-11.083 14.174-6.126 0-11.085-6.346-11.085-14.174"
      />
      <g stroke="#000">
        <path
          fill="#0044ad"
          strokeWidth={2.882}
          d="M401.292 602.334c0-35.24 24.348-63.803 54.42-63.803 30.054 0 54.407 28.563 54.407 63.803 0 35.255-24.353 63.837-54.406 63.837-30.073 0-54.42-28.582-54.42-63.837z"
          transform="matrix(.2037 0 0 .22204 157.315 148.89)"
        />
        <g fill="#9f7e00">
          <path
            d="M430.009 558.41s-6.462 7.08-6.462 13.632c0 6.591 2.73 12.061 2.73 12.061-.977-2.6-3.616-4.474-6.72-4.474-3.923 0-7.118 3.009-7.118 6.74 0 1.083.66 2.769 1.16 3.698l2.317 4.68c.767-1.725 2.573-2.687 4.676-2.687 2.811 0 5.101 2.146 5.101 4.818 0 .403-.053.81-.158 1.179l-5.8.02v4.934h5.172l-3.85 7.635 5.1-1.993 3.852 4.34 3.995-4.34 5.087 1.993-3.837-7.635h5.173v-4.934l-5.815-.02c-.105-.37-.124-.776-.124-1.179 0-2.672 2.246-4.818 5.063-4.818 2.103 0 3.909.962 4.69 2.687l2.299-4.68c.503-.93 1.164-2.615 1.164-3.698 0-3.731-3.176-6.74-7.119-6.74-3.104 0-5.724 1.873-6.706 4.474 0 0 2.712-5.47 2.712-12.061 0-6.553-6.596-13.632-6.596-13.632"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M419.734 603.01h20.708v-4.934h-20.708zm60.844-44.6s-6.457 7.08-6.457 13.632c0 6.591 2.711 12.061 2.711 12.061-.963-2.6-3.602-4.474-6.706-4.474-3.942 0-7.118 3.009-7.118 6.74 0 1.083.661 2.769 1.16 3.698l2.298 4.68c.79-1.725 2.592-2.687 4.695-2.687 2.816 0 5.082 2.146 5.082 4.818 0 .403-.035.81-.139 1.179l-5.8.02v4.934h5.172l-3.85 7.635 5.082-1.993 3.87 4.34 3.98-4.34 5.102 1.993-3.856-7.635h5.173v-4.934l-5.796-.02c-.11-.37-.143-.776-.143-1.179 0-2.672 2.265-4.818 5.087-4.818 2.103 0 3.904.962 4.67 2.687l2.319-4.68c.503-.93 1.154-2.615 1.154-3.698 0-3.731-3.185-6.74-7.113-6.74-3.1 0-5.748 1.873-6.72 4.474 0 0 2.725-5.47 2.725-12.061 0-6.553-6.596-13.632-6.596-13.632m-25.278 43.498s-6.457 7.08-6.457 13.652 2.73 12.042 2.73 12.042c-.981-2.601-3.606-4.474-6.725-4.474-3.923 0-7.118 3.008-7.118 6.74 0 1.096.661 2.768 1.16 3.697l2.318 4.68c.785-1.724 2.567-2.701 4.67-2.701 2.822 0 5.106 2.16 5.106 4.833 0 .421-.052.824-.162 1.197l-5.796.015v4.934h5.192l-3.856 7.636 5.087-2.008 3.851 4.34 3.995-4.34 5.102 2.008-3.87-7.636h5.187v-4.934l-5.796-.015a4.408 4.408 0 0 1-.144-1.197c0-2.673 2.271-4.833 5.088-4.833 2.098 0 3.884.977 4.675 2.701l2.318-4.68c.494-.929 1.16-2.6 1.16-3.697 0-3.732-3.196-6.74-7.119-6.74-3.104 0-5.724 1.873-6.725 4.474 0 0 2.73-5.47 2.73-12.042s-6.62-13.652-6.62-13.652"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
          <path
            d="M445.012 646.523h20.707v-4.934h-20.707zm25.272-43.513h20.708v-4.934h-20.708z"
            transform="matrix(.2037 0 0 .22204 157.315 148.89)"
          />
        </g>
      </g>
      <g stroke="#000">
        <path
          fill="none"
          strokeWidth={3.973}
          d="M455.882 903.768c-60.601 0-120.666-15.257-171.164-40.63-37.223-18.935-61.904-57.112-61.904-100.797V603.92l-.298-265.316h465.498l.018 265.316v158.42c0 43.685-24.68 81.862-61.907 100.797-50.494 25.373-109.622 40.63-170.242 40.63z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#9f7e00"
          fillRule="evenodd"
          strokeWidth={1.3}
          d="M747.402 807.171h106.104v27.759H747.402z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
        <path
          fill="#9f7e00"
          strokeWidth={1.3}
          d="M56.377 807.171h106.114v27.759H56.377z"
          transform="matrix(.20919 0 0 .22204 154.82 148.89)"
        />
      </g>
    </svg>
  )
}
